import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import {  DatePipe, Location } from '@angular/common';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MenuItem, MessageService,ConfirmationService } from 'primeng/api';
import { VendorTsService } from '../../../../service/vendor/vendor.ts.service';
import { AuthService } from '../../../../service/frappe/auth.service';
import { UserService } from '../../../../service/user-service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AbstractControl } from '@angular/forms';
import { ShipmentASN } from '../../../../service/shipment-asn.service';
import { Subscription } from 'rxjs';
import { an } from '@fullcalendar/core/internal-common';
import { environment } from '../../../../../environments/environment';
import { WithHoldingTaxDto } from '../../../../models/with-holding-tax-dto';
import { PendingVendorDto } from '../../../../models/pending-vendor-dto';
interface PlantWithCode{
  plant__code:string
  name1:string
}
interface CityAndState {
  city: string;
  state: string;
  name: string;
  state_code: string;
}
interface PaymentTerm {
  payment_term_description: string;
  payment_term_code: string;
}
interface AccountGroup {
  label: string;
  value: string;
}
interface WithHoldingTaxCode {
  tax_code: string;
  description: string;
}
interface WithHoldingTaxType {
  tax_type: string;
  description: string;
  tax_code: string;
  descriptionMain: string;
}
interface ReconciliationType {
  type: string;
  description: string;
}
interface VendorPayableAccountsList {
  code: string;
  description: string;
}
const FIELD_ORDER = [
  // Company Information
  'company_title',
  'business_name',
  'vendor_code',
  'short_name',
  'plant',

  // Primary Address
  'primary_address.address_title',
  'primary_address.address_line_1',
  'primary_address.address_line_2',
  'primary_address.country',
  'primary_address.city',
  'primary_address.state',
  'primary_address.postal_code',
  'primary_address.fax',

  // MCA Details
  'ministry_of_corporate_affairsmca',
  'mca_number',
  'mca_document',

  // GST & Industry Details
  'gst_registered',
  'select_industry_type',
  'primary_address.tax_details.gstn',
  'primary_address.tax_details.upload_gst',
  'primary_address.tax_details.vat_registration_number',
  'primary_address.tax_details.service_tax_registration_number',

  // Vendor Details
  'vendor_type',
  'propertiery_img',

  // Vendor Classification
  'vendor_classification',

  // Turnover Details
  'previous_year',
  'one_year_before_previous_year',
  'two_years_before_previous_year',

  // Bank Details Array
  'primary_address.multiple_bank_detail.ifsc_code',
  'primary_address.multiple_bank_detail.account_no',
  'primary_address.multiple_bank_detail.account_holder__registered_name',
  'primary_address.multiple_bank_detail.plant_code',
  'primary_address.multiple_bank_detail.bank_name',
  'primary_address.multiple_bank_detail.branch_name',

  // Legal Details
  'pan_no',
  'pan_document',
  'msme_no',
  'msme_expiry_year',
  'msme_certificate',
  'cin_no',
  'upload_cin',
  'legal_name',
  'tin_no',
  'aadhar_no',
  'din_no',

  // Legal Documents
  'self_declaration_by_vendor',
  'company_registration',
  'other_documents',

  // Evaluation Documents
  'evaluation_sheet',
  'document_1_name', // Company Profile
  'document_1',
  'document_2_name', // Balance Sheet
  'document_2',
  'document_3_name', // Auditor Report
  'document_3',
  'document_4_name', // ISO Certificate
  'document_4',
  'document_5_name', // List of Equipment
  'document_5',
  'document_6_name', // Other
  'document_6',

  // Contact Details
  'vm_contact_detail.contacts',
  'vm_contact_detail.telephone',
  'vm_contact_detail.email_id',
  'vm_contact_detail.mobile_phone',

  // Rockman Contact Details
  'contact.rockmancontacts',
  'contact.first_name',
  'contact.last_name',
  'contact.rockman_contact_department',
  'contact.rockman_contact_function',

];


@Component({
  selector: 'app-view-vendor-details',
  templateUrl: './view-vendor-details.component.html',
  styleUrl: './view-vendor-details.component.scss'
})
export class ViewVendorDetailsComponent {
  @Output() userFoundChange = new EventEmitter<boolean>();

  contactForm!: FormGroup;
  rockmancontactForm!: FormGroup;
  multipleBankDetailForm!: FormGroup;
  savedContacts: any[] = [];
  msmeYearList: any[] = [];
  noContacts: boolean = false;
  noRockmanContacts: boolean = false;
  enableMSMEUploadButton: boolean = true;
  enableMSMEYearInvalidMessage: boolean = false;
  createSub$!: Subscription;

  content = "Contact";
  detail1 = 'Contact saved or updated successfully';
  detail2 = 'Error saving or updating contact';
  detail3 = 'Invalid contact data. Cannot save or update';

  registrationForm!: FormGroup;
  items: MenuItem[] = [];
  FRAPPE_API_URL = environment.FRAPPE_API_URL;
  FRAPPE_API_URL_PROD = environment.FRAPPE_API_URL;
  displayDialog: boolean = false;
  missingFields: string[] = [];
  msmeCertificateFile: File | null = null;
  companyRegistrationFile: File | null = null;
  vendorImageFile: File | null = null;
  otherDocumentsFiles: File | null = null;
  uploadGstFile: File | null = null;
  uploadCIN: File | null = null;
  cancelledCheque: File | null = null;
  selfDeclarationByVendor: File | null = null;
  evaluationSheet: File | null = null;
  mcaDocument: File | null = null;
  panDocument: File | null = null;
  document1: File | null = null;
  document2: File | null = null;
  document3: File | null = null;
  document4: File | null = null;
  document5: File | null = null;
  document6: File | null = null;
  activeIndex: number = 0;
  loggedInUser: string = '';
  submitted = false;
  selectedValue: any;
  selectedValue1: any;
  checkbox1: boolean = false;
  checkbox2: boolean = false;
  checkbox3: boolean = false;
  checkbox4: boolean = false;
  evaluationSheetUrl!: string;
  document1Url!: string;
  document2Url!: string;
  document3Url!: string;
  document4Url!: string;
  document5Url!: string;
  document6Url!: string;
  msme_certificateUrl!: string
  company_registrationUrl!: string
  other_documentsUrl!: string
  upload_cinUrl!: string
  propertiery_imgUrl!: string
  mca_documentUrl!: string
  self_declaration_by_vendorUrl!: string
  pan_documentUrl!: string
  upload_gstUrl!: string
  cancelled_chequeUrl!: string
  riskScore_doc!: string
  evaluatedScore_doc!: string
  plantList: any[] = [];
  formValues:any
  isDisablePan: boolean = true;
  isNotEditable: boolean = true;
  isLoading: boolean = false;
  isIndustry: boolean = false;
  // countries: any[] | undefined
  countries_code: any;
  selectedCountrieCode?: any;
  selectedOptionLabel: string = 'name';
  business_name:string=''
  get_user:string=''
  propertiery_img:string=''
  status:string=''
  currentYear: number = 0;
  financialPreviousYear: number = 0;
  financialOneYearBeforePreviousYear: number = 0;
  financialtwoYearsBeforePreviousYear: number = 0;

  vendor: any;
  documents: { name: string, file: string, document_name: string }[] = []; // Add documents array
  legalDocuments: { name: string, file: string }[] = [];
  thridPartyScoreDocuments: { name: string, file: string }[] = [];
  vendorList: any[] = [];
  vm_contact_detail: any[] = [];
  contact_persion: any[] = [];

  selectedVendorList: string[] = [];
  paymentterm1: any[] = [];
  accountGroupList: any[] = [];

  isVendorStatus: boolean = false
  isAuditorApprovalForChange: boolean = false
  accountgroup: string = '';
  withholdingtax: string = '';
  purchaseOrgannization: string = '';
  newAccountGroup: string = '';
  paymentTerm: string = '';
  purchasingOrganization: string = '';
  riskScore: string = '';
  evaluatedScore: string = '';
  paymentterm: any[] = []
  isPendingApproval1 = false
  isPendingApproval2 = false
  isPendingCPOApproval = false
  isSelectNo = false
  pendingreview = false
  pendingApprovalForDialog = false
  isFinalApproved=false
  pendingRejectForDialog = false
  is_need_Detail = false
  isDialogSummary = false
  scoreList: string[] = [];
  PendingVendorDto: PendingVendorDto

  thrid_party_evaluated_scorecard_doc: File | null = null;
  thrid_party_business_score_doc: File | null = null;
  isRejectDialog = false
  isApproveDialog = false
  isWithHoldingTaxYes = false
  rejectReason: string=''
  Wthttype: any =''
  Wtaxcode: any=''
  RectyData: any = ''
  WithHoldingTaxType: string = ''
  WithHoldingTaxCodeName: string = ''
  reconciliationName: string = ''
  ExemptionNumber: string = ''
  Exem: string = ''
  ExemptFrom?: Date | null;
  ExemptTo?: Date | null;
  headerStatus: string = ''
  cin: string = ''
  pan_doc: string = ''
  msme_doc: string = ''
  mca_doc: string = ''
  profile_doc: string = ''
  gst_doc: string = ''
  bank_doc: string = ''
  company_registration_doc: string = ''
  other_doc: string = ''
  self_declaration_by_vendor: string = ''
  highlights_detail:any
  isVendor = false
  withHoldingTaxCode: any[] = []
  withHoldingTaxCode1: any[] = []
  withHoldingTaxTypeList: any[] = []
  reconciliationTypeList: any[] = []
  vendorPayableAccountsList: any[] = []

  sidebarVisible:boolean = false
  withHoldingMultiData: WithHoldingTaxDto[] = [];
  isApproved = true
  isApproved2 = false
  businessName2:string=''
  isAuditor=false
  remark_for_vendor_query:string=''
  bank_data:any[] =[]
  other_data:any[]=[]
  options = [
    { label: 'Individual', value: 'Individual' },
    { label: 'Partnership', value: 'Partnership' },
    { label: 'Corporation', value: 'Corporation' },
    {
      label: 'Limited Liability Co. (LLC)',
      value: 'Limited Liability Co. (LLC)',
    },
    { label: 'Limited', value: 'Limited' },
    { label: 'Govt.Org', value: 'Govt.Org' },
  ];
  MCA = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
  ];
  VendorType = [
    { label: 'Goods', value: 'Goods' },
    { label: 'Service', value: 'Service' },
  ];
  SelectIndustryType = [
    { label: 'Micro Industry', value: '0001' },
    { label: 'Small Industry', value: '0002' },
    { label: 'Medium Industry', value: '0003' },
    { label: 'Large Industry', value: '0004' },
    { label: 'Other', value: '0005' },
  ];

  countries_List = [
    { label: 'Afghanistan', value: 'AF' },
    { label: 'Albania', value: 'AL' },
    { label: 'Algeria', value: 'DZ' },
    { label: 'Andorra', value: 'AD' },
    { label: 'Angola', value: 'AO' },
    { label: 'Antigua and Barbuda', value: 'AG' },
    { label: 'Argentina', value: 'AR' },
    { label: 'Armenia', value: 'AM' },
    { label: 'Australia', value: 'AU' },
    { label: 'Austria', value: 'AT' },
    { label: 'Azerbaijan', value: 'AZ' },
    { label: 'Bahamas', value: 'BS' },
    { label: 'Bahrain', value: 'BH' },
    { label: 'Bangladesh', value: 'BD' },
    { label: 'Barbados', value: 'BB' },
    { label: 'Belarus', value: 'BY' },
    { label: 'Belgium', value: 'BE' },
    { label: 'Belize', value: 'BZ' },
    { label: 'Benin', value: 'BJ' },
    { label: 'Bhutan', value: 'BT' },
    { label: 'Bolivia', value: 'BO' },
    { label: 'Bosnia and Herzegovina', value: 'BA' },
    { label: 'Botswana', value: 'BW' },
    { label: 'Brazil', value: 'BR' },
    { label: 'Brunei', value: 'BN' },
    { label: 'Bulgaria', value: 'BG' },
    { label: 'Burkina Faso', value: 'BF' },
    { label: 'Burundi', value: 'BI' },
    { label: 'Cabo Verde', value: 'CV' },
    { label: 'Cambodia', value: 'KH' },
    { label: 'Cameroon', value: 'CM' },
    { label: 'Canada', value: 'CA' },
    { label: 'Central African Republic', value: 'CF' },
    { label: 'Chad', value: 'TD' },
    { label: 'Chile', value: 'CL' },
    { label: 'China', value: 'CN' },
    { label: 'Colombia', value: 'CO' },
    { label: 'Comoros', value: 'KM' },
    { label: 'Congo, Democratic Republic of the', value: 'CD' },
    { label: 'Congo, Republic of the', value: 'CG' },
    { label: 'Costa Rica', value: 'CR' },
    { label: 'Croatia', value: 'HR' },
    { label: 'Cuba', value: 'CU' },
    { label: 'Cyprus', value: 'CY' },
    { label: 'Czech Republic', value: 'CZ' },
    { label: 'Denmark', value: 'DK' },
    { label: 'Djibouti', value: 'DJ' },
    { label: 'Dominica', value: 'DM' },
    { label: 'Dominican Republic', value: 'DO' },
    { label: 'Ecuador', value: 'EC' },
    { label: 'Egypt', value: 'EG' },
    { label: 'El Salvador', value: 'SV' },
    { label: 'Equatorial Guinea', value: 'GQ' },
    { label: 'Eritrea', value: 'ER' },
    { label: 'Estonia', value: 'EE' },
    { label: 'Eswatini', value: 'SZ' },
    { label: 'Ethiopia', value: 'ET' },
    { label: 'Fiji', value: 'FJ' },
    { label: 'Finland', value: 'FI' },
    { label: 'France', value: 'FR' },
    { label: 'Gabon', value: 'GA' },
    { label: 'Gambia', value: 'GM' },
    { label: 'Georgia', value: 'GE' },
    { label: 'Germany', value: 'DE' },
    { label: 'Ghana', value: 'GH' },
    { label: 'Greece', value: 'GR' },
    { label: 'Grenada', value: 'GD' },
    { label: 'Guatemala', value: 'GT' },
    { label: 'Guinea', value: 'GN' },
    { label: 'Guinea-Bissau', value: 'GW' },
    { label: 'Guyana', value: 'GY' },
    { label: 'Haiti', value: 'HT' },
    { label: 'Honduras', value: 'HN' },
    { label: 'Hungary', value: 'HU' },
    { label: 'Iceland', value: 'IS' },
    { label: 'India', value: 'IN' },
    { label: 'Indonesia', value: 'ID' },
    { label: 'Iran', value: 'IR' },
    { label: 'Iraq', value: 'IQ' },
    { label: 'Ireland', value: 'IE' },
    { label: 'Israel', value: 'IL' },
    { label: 'Italy', value: 'IT' },
    { label: 'Ivory Coast', value: 'CI' },
    { label: 'Jamaica', value: 'JM' },
    { label: 'Japan', value: 'JP' },
    { label: 'Jordan', value: 'JO' },
    { label: 'Kazakhstan', value: 'KZ' },
    { label: 'Kenya', value: 'KE' },
    { label: 'Kiribati', value: 'KI' },
    { label: 'Kuwait', value: 'KW' },
    { label: 'Kyrgyzstan', value: 'KG' },
    { label: 'Laos', value: 'LA' },
    { label: 'Latvia', value: 'LV' },
    { label: 'Lebanon', value: 'LB' },
    { label: 'Lesotho', value: 'LS' },
    { label: 'Liberia', value: 'LR' },
    { label: 'Libya', value: 'LY' },
    { label: 'Liechtenstein', value: 'LI' },
    { label: 'Lithuania', value: 'LT' },
    { label: 'Luxembourg', value: 'LU' },
    { label: 'Madagascar', value: 'MG' },
    { label: 'Malawi', value: 'MW' },
    { label: 'Malaysia', value: 'MY' },
    { label: 'Maldives', value: 'MV' },
    { label: 'Mali', value: 'ML' },
    { label: 'Malta', value: 'MT' },
    { label: 'Marshall Islands', value: 'MH' },
    { label: 'Mauritania', value: 'MR' },
    { label: 'Mauritius', value: 'MU' },
    { label: 'Mexico', value: 'MX' },
    { label: 'Micronesia', value: 'FM' },
    { label: 'Moldova', value: 'MD' },
    { label: 'Monaco', value: 'MC' },
    { label: 'Mongolia', value: 'MN' },
    { label: 'Montenegro', value: 'ME' },
    { label: 'Morocco', value: 'MA' },
    { label: 'Mozambique', value: 'MZ' },
    { label: 'Myanmar', value: 'MM' },
    { label: 'Namibia', value: 'NA' },
    { label: 'Nauru', value: 'NR' },
    { label: 'Nepal', value: 'NP' },
    { label: 'Netherlands', value: 'NL' },
    { label: 'New Zealand', value: 'NZ' },
    { label: 'Nicaragua', value: 'NI' },
    { label: 'Niger', value: 'NE' },
    { label: 'Nigeria', value: 'NG' },
    { label: 'North Korea', value: 'KP' },
    { label: 'North Macedonia', value: 'MK' },
    { label: 'Norway', value: 'NO' },
    { label: 'Oman', value: 'OM' },
    { label: 'Pakistan', value: 'PK' },
    { label: 'Palau', value: 'PW' },
    { label: 'Panama', value: 'PA' },
    { label: 'Papua New Guinea', value: 'PG' },
    { label: 'Paraguay', value: 'PY' },
    { label: 'Peru', value: 'PE' },
    { label: 'Philippines', value: 'PH' },
    { label: 'Poland', value: 'PL' },
    { label: 'Portugal', value: 'PT' },
    { label: 'Qatar', value: 'QA' },
    { label: 'Romania', value: 'RO' },
    { label: 'Romania', value: 'RO' },
    { label: 'Russia', value: 'RU' },
    { label: 'Rwanda', value: 'RW' },
    { label: 'Saint Kitts and Nevis', value: 'KN' },
    { label: 'Saint Lucia', value: 'LC' },
    { label: 'Saint Vincent and the Grenadines', value: 'VC' },
    { label: 'Samoa', value: 'WS' },
    { label: 'San Marino', value: 'SM' },
    { label: 'Sao Tome and Principe', value: 'ST' },
    { label: 'Saudi Arabia', value: 'SA' },
    { label: 'Senegal', value: 'SN' },
    { label: 'Serbia', value: 'RS' },
    { label: 'Seychelles', value: 'SC' },
    { label: 'Sierra Leone', value: 'SL' },
    { label: 'Singapore', value: 'SG' },
    { label: 'Slovakia', value: 'SK' },
    { label: 'Slovenia', value: 'SI' },
    { label: 'Solomon Islands', value: 'SB' },
    { label: 'Somalia', value: 'SO' },
    { label: 'South Africa', value: 'ZA' },
    { label: 'South Korea', value: 'KR' },
    { label: 'South Sudan', value: 'SS' },
    { label: 'Spain', value: 'ES' },
    { label: 'Sri Lanka', value: 'LK' },
    { label: 'Sudan', value: 'SD' },
    { label: 'Suriname', value: 'SR' },
    { label: 'Sweden', value: 'SE' },
    { label: 'Switzerland', value: 'CH' },
    { label: 'Syria', value: 'SY' },
    { label: 'Taiwan', value: 'TW' },
    { label: 'Tajikistan', value: 'TJ' },
    { label: 'Tanzania', value: 'TZ' },
    { label: 'Thailand', value: 'TH' },
    { label: 'Timor-Leste', value: 'TL' },
    { label: 'Togo', value: 'TG' },
    { label: 'Tonga', value: 'TO' },
    { label: 'Trinidad and Tobago', value: 'TT' },
    { label: 'Tunisia', value: 'TN' },
    { label: 'Turkey', value: 'TR' },
    { label: 'Turkmenistan', value: 'TM' },
    { label: 'Tuvalu', value: 'TV' },
    { label: 'Uganda', value: 'UG' },
    { label: 'Ukraine', value: 'UA' },
    { label: 'United Arab Emirates', value: 'AE' },
    { label: 'United Kingdom', value: 'GB' },
    { label: 'United States', value: 'US' },
    { label: 'Uruguay', value: 'UY' },
    { label: 'Uzbekistan', value: 'UZ' },
    { label: 'Vanuatu', value: 'VU' },
    { label: 'Vatican City', value: 'VA' },
    { label: 'Venezuela', value: 'VE' },
    { label: 'Vietnam', value: 'VN' },
    { label: 'Yemen', value: 'YE' },
    { label: 'Zambia', value: 'ZM' },
    { label: 'Zimbabwe', value: 'ZW' },
  ];

  GST_Registered = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
  ];
  Company_Title = [
    { label: 'Company', value: 'Company' },
    { label: 'MR.', value: 'Mr.' },
    { label: 'Ms.', value: 'Ms.' },
    { label: 'Mr. & Mrs.', value: 'Mr. & Mrs.' },
  ];
  Rockman_contact_department = [
    { label: 'Managining Director', value: '0001' },
    { label: 'Purchaing', value: '0002' },
    { label: 'Sales', value: '0003' },
    { label: 'Organization', value: '0004' },
    { label: 'Adminstration', value: '0005' },
    { label: 'Production', value: '0006' },
    { label: 'Quality Assurance', value: '0007' },
    { label: 'Secretaries', value: '0008' },
    { label: 'Financial Department', value: '0009' },
    { label: 'Legal Department', value: '0010' },
  ];

  Rockman_contact_function = [
    { label: 'Executive Board', value: '01' },
    { label: 'Head of Purchaing', value: '02' },
    { label: 'Head of Sales', value: '03' },
    { label: 'Head of Personnel', value: '04' },
    { label: 'Janitor', value: '05' },
    { label: 'Head of the Canteen', value: '06' },
    { label: 'Personal Assistant', value: '07' },
    { label: 'Edp Manager', value: '08' },
    { label: 'Fin.Accountg Manager', value: '09' },
    { label: 'Marketing Manager', value: '10' },
  ];

  countries = [
    { label: 'Afghanistan (+93)', value: '+93' },
    { label: 'Australia (+61)', value: '+61' },
    { label: 'China (+86)', value: '+86' },
    { label: 'Egypt (+20)', value: '+20' },
    { label: 'France (+33)', value: '+33' },
    { label: 'Germany (+49)', value: '+49' },
    { label: 'India (+91)', value: '+91' },
    { label: 'Japan (+81)', value: '+81' },
    { label: 'Spain (+34)', value: '+34' },
    { label: 'United Kingdom (+44)', value: '+44' },
    { label: 'United States (+1)', value: '+1' },
  ];
  state = [
    { label: 'Andaman and Nico.In.', value: '26' },
    { label: 'Andra Pradesh', value: '01' },
    { label: 'Arunachal Pradesh', value: '02' },
    { label: 'Assam', value: '03' },
    { label: 'Bihar', value: '04' },
    { label: 'Chandigarh', value: '27' },
    { label: 'Chhaattisgarh', value: '33' },
    { label: 'Dadra und Nagar Hav.', value: '28' },
    { label: 'Daman und Diu', value: '29' },
    { label: 'Delhi', value: '30' },
    { label: 'Exports', value: '96' },
    { label: 'Goa', value: '05' },
    { label: 'Gujarat', value: '06' },
    { label: 'Haryana', value: '07' },
    { label: 'Himachal Pradesh', value: '08' },
    { label: 'Jammu and Kashmir', value: '09' },
    { label: 'Jharkhand', value: '34' },
    { label: 'Karnataka', value: '10' },
    { label: 'Kerala', value: '11' },
    { label: 'Lakshadweep', value: '31' },
    { label: 'Madhya Pradesh', value: '12' },
    { label: 'Maharashtra', value: '13' },
    { label: 'Manipur', value: '14' },
    { label: 'Megalaya', value: '15' },
    { label: 'Mizoram', value: '16' },
    { label: 'Nagaland', value: '17' },
    { label: 'Orissa', value: '18' },
    { label: 'Other - Exports', value: '00' },
    { label: 'Pondicherry', value: '32' },
    { label: 'Punjab', value: '19' },
    { label: 'Rajasthan', value: '20' },
    { label: 'Sikkim', value: '21' },
    { label: 'Tamil Nadu', value: '22' },
    { label: 'Telangana', value: '36' },
    { label: 'Tripura', value: '23' },
    { label: 'Uttar Pradesh', value: '24' },
    { label: 'Uttarakhand', value: '35' },
    { label: 'West Bengal', value: '25' },
  ];

  options1 = [
    { label: 'Billing', value: 'Billing' },
    { label: 'Shipping', value: 'Shipping' },
    { label: 'Office', value: 'Office' },
    { label: 'Personal', value: 'Personal' },
    { label: 'Plant', value: 'Plant' },
    { label: 'Postal', value: 'Postal' },
    { label: 'Shop', value: 'Shop' },
    { label: 'Subsidiary', value: 'Subsidiary' },
    { label: 'Warehouse', value: 'Warehouse' },
    { label: 'Current', value: 'Current' },
    { label: 'Permanent', value: 'Permanent' },
    { label: 'Other', value: 'Other' },
  ];
  PurchasingOrganization = [
    { label: '1000-Pur.Org-Domestic', value: '1000' },
    { label: '2000-Pur.Org-Import', value: '2000' },
  ]

  bankPlantNameAndCode = [
    { label: 'ROCKMAN HARIDWAR(RILH)', value: 'RILH' },
    { label: 'ROCKMAN LUDHIANA(RILL)', value: 'RILL' },
    { label: 'ROCKMAN MANGLI(RILM)', value: 'RILM' },
    { label: 'ROCKMAN BAWAL(RILB)', value: 'RILB' },
    { label: 'ROCKMAN VADODARA(RILV)', value: 'RILV' },
    { label: 'ROCKMAN TIRUPATI(RILT)', value: 'RILT' },
    { label: 'ROCKMAN CHENNAI(RILC)', value: 'RILC' },
    { label: 'ROCKMAN CHENNAI 2(RIC2)', value: 'RIC2' },
    { label: 'ROCKMAN CORPORTAE(RILG)', value: 'RILG' },
  ]

  vendor_query_remark:any
  approvalStatus:string=''
  highlightStatus: { [key: string]: boolean } = {};
  vendorAllDetail: any
  cityAndStateList: any[] = [];
  bankUploadedFiles: any[] = [];
  patchBankUploaded: any[] = [];

  is_purchase_approver_1=false
  is_finance_approver_2=false
  isPurchase=false
  showApprovalButtons: boolean = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    public messageService: MessageService,
    private vendorService: VendorTsService,
    public authService: AuthService,
    public userService: UserService,
    private router: Router,
    private location: Location,
    private shipment_asn: ShipmentASN,
    private datePipe: DatePipe,
    private confirmationService: ConfirmationService,
    private cd: ChangeDetectorRef // Inject ChangeDetectorRef

  ) {
    this.PendingVendorDto = new PendingVendorDto()
  }

  public withholdingtax1 = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" }
  ]

   ngOnInit() {

    const vendorDetail = history.state;
    let vendorStatus = '';
    if (vendorDetail) {
      vendorStatus = vendorDetail.status;

    } else {
      console.log('No selected rows found.');
    }

    this.vendorService.checkIfVendor()
    .then((response) => {
      this.isVendor = response.message.roles.includes("Vendor")
      this.isAuditor=response.message.roles.includes("Vendor Auditor")

      const userRoles = response.message.roles;
      const hasPendingVendor = userRoles.includes("Pending Approval");
      const hasPurchaseApproval = userRoles.includes("Purchase(Other Changes)");
      const hasFinanceApproval = userRoles.includes("Finance(Bank Detail Changes)");

      const onlyHasPendingApproval = hasPendingVendor &&
                                    !hasPurchaseApproval &&
                                    !hasFinanceApproval;

      // Check for special cases to hide buttons based on status and roles
      const isPendingVendorWithPurchase = hasPendingVendor && hasPurchaseApproval;
      const isPendingVendorWithFinance = hasPendingVendor && hasFinanceApproval;

      // Hide buttons if status is Finance Approval 2 for users with Pending Vendor + Purchase Approval
      const hideForFinanceApproval2 = isPendingVendorWithPurchase &&
                                     vendorStatus === "FINANCE_APPROVER_2";

      // Hide buttons if status is Pending Purchase or Purchase Approval for users with Pending Vendor + Finance Approval
      const hideForPurchaseStatus = isPendingVendorWithFinance &&
                                   (vendorStatus === "PENDING_PURCHASE" ||
                                    vendorStatus === "PURCHASE_APPROVER_1");

      if (onlyHasPendingApproval || hideForFinanceApproval2 || hideForPurchaseStatus) {
        this.showApprovalButtons = false;
      }
      else if (hasPendingVendor || hasPurchaseApproval || hasFinanceApproval) {
        this.showApprovalButtons = true;
      }
      else {
        this.showApprovalButtons = false;
      }
    }).catch((error) => {
      console.log(error);
    });

    this.CityAndState(vendorDetail);
  // const businessName = this.route.snapshot.paramMap.get('id');
  this.multipleBankDetailForm = this.fb.group({
    multipleBank: this.fb.array([]),
  });

    for (let i = 0; i <= 100; i++) {
      this.scoreList.push(i.toString());
    }

    this.contactForm = this.fb.group({
      contacts: this.fb.array([]),
    });
    // for (let i = 0; i <= 1; i++) {
    //   this.addContact();
    // }

    this.rockmancontactForm = this.fb.group({
      rockmancontacts: this.fb.array([]),
    });
    // this.addRockmanContact();

    this.registrationForm = this.fb.group(
      {
        new_vm_contact_detail: this.fb.control(''),
        new_rockman_contact_detail: this.fb.control(''),
        vendor_code: [''],
        plant: ['', Validators.required],
        note: ['',],
        company_title: [''],
        ministry_of_corporate_affairsmca: [''],
        mca_number: [''],
        select_industry_type: ['', Validators.required],
        gst_registered: ['', Validators.required],
        vendor_type: [''],
        business_name: ['', Validators.required],
        vendor_classification: [''],
        short_name: ['', Validators.required],
        status: [''],
        propertiery_img: [''],
        previous_year: [''],
        one_year_before_previous_year: [''],
        two_years_before_previous_year: [''],
        financial_previous_year: [''],
        financial_one_year_before_previous_year: [''],
        financial_two_years_before_previous_year: [''],
        legal_name: [''],
        pan_no: ['', [Validators.required, this.panValidator]],
        cin_no: ['', [Validators.required]],
        tin_no: [''],
        din_no: [''],
        msme_no: [''],
        aadhar_no: ['', [Validators.pattern(/^\d{12}$/)]],
        msme_certificate: [''],
        company_registration: ['', [Validators.required]],
        other_documents: [''],
        upload_cin: ['', [Validators.required]],
        self_declaration_by_vendor: ['',],
        mca_document: [''],
        pan_document: ['', [Validators.required]],
        evaluation_sheet: ['', [Validators.required]],
        document_1: ['', [Validators.required]],
        document_2: ['', [Validators.required]],
        document_3: ['',],
        document_4: ['',],
        document_5: ['',],
        document_6: ['',],
        document_1_name: ['', [Validators.required]],
        document_2_name: ['', [Validators.required]],
        document_3_name: ['',],
        document_4_name: ['',],
        document_5_name: ['',],
        document_6_name: ['',],
        get_user: [''],
        msme_expiry_year: [''],
        highlights_detail: [''],
        thrid_party_evaluated_score: [''],
        thrid_party_risk_score: [''],
        primary_address: this.fb.group({
          address_title: ['', Validators.required],
          address_line_1: ['', Validators.required],
          address_line_2: ['', Validators.required],
          city: [''],
          country: ['', Validators.required],
          state: [''],
          state1: [''],
          postal_code: ['', [Validators.required, Validators.pattern('^[0-9]{1,6}$')]],
          email_address: ['', [Validators.email]],
          phone_no: [''],
          fax: [''],
          address_summary: [''],
          address_type: [''],
          preferred_billing_address: [''],
          preferred_shipping_address: [''],
          disabled: [''],
          is_primary: [''],
          contact_person: this.fb.group({
            name1: [''],
            phone_no: [''],
            mobile_no: [''],
            e_mail_id: [''],
            website_url: [''],
            alternate_email_id: [''],
          }),
          // bank_detail: this.fb.group({
          //   account_holder__registered_name: ['', Validators.required],
          //   account_no: ['', [Validators.required, this.noSpecialCharactersValidator]],
          //   bank_name: ['', Validators.required],
          //   bank_address: ['', Validators.required],
          //   ifsc_code: ['', [Validators.required]],
          //   cancelled_cheque: ['',Validators.required],
          //   branch_name: ['', Validators.required],
          //   bank_city: ['', Validators.required],
          //   bank_region: ['', Validators.required],
          // }),
          multiple_bank_detail: this.fb.control(''),
          tax_details: this.fb.group({
            gstn: [''],
            vat_registration_number: [''],
            service_tax_registration_number: [''],
            upload_gst: [''],
          }),
        }),
      },
      { validator: this.emailMatchValidator }
    );


    this.vendorService.getPaymentTerms().then((response) => {
      this.paymentterm = response.message

      this.paymentterm.forEach((pt) => {
        let pt1: PaymentTerm = {
          payment_term_code: pt.payment_term_code,
          payment_term_description: `${pt.payment_term_code}-${pt.payment_term_description}`
        };

        this.paymentterm1.push(pt1);
      });
    }).catch((error) => {
      console.log(error)
    })
    this.vendorService.account_group_list().then((response) => {
      // console.log(response.message)
      // this.accountGroupList=response.message
      response.message.forEach((pt:any) => {
        let pt1: AccountGroup = {
          value: pt.group,
          label: `${pt.group}-${pt.name1}`
        };
        this.accountGroupList.push(pt1);
      });

    }).catch((error) => {
      console.log(error)
    })

    this.vendorService.getWithHoldingTaxCode().then((response) => {
    this.withHoldingTaxCode1=response.message
    }).catch((error) => {
      console.log(error)
    })

    this.vendorService.getWithHoldingTaxType().then((response) => {

      response.message.forEach((pt:any) => {
        let pt1: WithHoldingTaxType = {
          tax_type: pt.tax_type,
          description: `${pt.tax_type}-${pt.description}`,
          tax_code: pt.tax_code,
          descriptionMain: pt.description,
        };

        this.withHoldingTaxTypeList.push(pt1);
      });

    }).catch((error) => {
      console.log(error)
    })

    this.vendorService.ReconciliationType().then((response) => {
      response.message.forEach((pt:any) => {
        let pt1: ReconciliationType = {
          type: pt.type,
          description: `${pt.type}-${pt.description}`
        };

        this.reconciliationTypeList.push(pt1);
      });

    }).catch((error) => {
      console.log(error)
    })

    this.vendorService.VendorPayableAccounts().then((response) => {
      response.message.forEach((pt:any) => {
        let pt1:VendorPayableAccountsList= {
          code: pt.code,
          description: `${pt.code}-${pt.description}`
        };

        this.vendorPayableAccountsList.push(pt1);
      });
    }).catch((error) => {
      console.log(error)
    })


    this.items = [
      {
        label: 'General Information',
        command: (event: any) => {
          this.activeIndex = 0;
          this.messageService.add({
            severity: 'info',
            summary: 'First Step',
            detail: 'General Information',
          });
        },
      },
      {
        label: 'Registration Details',
        command: (event: any) => {
          this.activeIndex = 1;
          this.messageService.add({
            severity: 'info',
            summary: 'Second Step',
            detail: 'Registration Details',
          });
        },
      },
    ];
    this.getLoggedInUser();
    this.generateYearList();


    this.currentYear = new Date().getFullYear();
    this.financialPreviousYear = this.currentYear - 1;
    this.financialOneYearBeforePreviousYear = this.currentYear - 2;
    this.financialtwoYearsBeforePreviousYear = this.currentYear - 3;
    this.registrationForm.disable()
  }
  get multipleBank(): FormArray {
    return this.multipleBankDetailForm.get('multipleBank') as FormArray;
  }


  removeBankDetail(index: number) {
    const multipleBankDetail= this.multipleBankDetailForm.get('multipleBank') as FormArray;
    // rockmancontactsArray.removeAt(index);
    if (multipleBankDetail.length > 1) {
      multipleBankDetail.removeAt(index);
    }
    // this.noRockmanContacts = rockmancontactsArray.length === 0;
  }

  CityAndState(vendorDetail: any){
    this.vendorService.getCityAndState().then((res)=>{
      this.cityAndStateList = res.message
      this.getPlantList(vendorDetail);
    }).catch((error)=>{
      console.log(error)
    })
  }

  goBack(): void {
    this.location.back();
  }

  getShortKey(longKey: string): string | null  {
    const keyMap: { [key: string]: string } = {
      // "new_rockman_contact_detail.1":"new_rockman_contact_detail 1",
      // "new_vm_contact_detail.3":"new_vm_contact_detail 3",
      "short_name":'Short Name',
      "plant":'Plant',
      "primary_address.address_title":"Address Title",
      "primary_address.address_line_1":"Street / House Number",
      "primary_address.address_line_2":"District",
      "primary_address.country":"Country",
      "primary_address.city":"City",
      "primary_address.state":"State/Province",
      "primary_address.postal_code":"Postal Code",
      "primary_address.fax":"Fax",
      "mca_number":'MCA Number',
      "mca_document":"MCA Document",
      "select_industry_type":"Select Industry Type",
      "primary_address.tax_details.upload_gst": 'GST Document',
      'primary_address.tax_details.vat_registration_number': 'Vat Registration Number',
      'primary_address.tax_details.service_tax_registration_number': 'Service Tax Registration Number',
      "vendor_type":"Vendor Type",
      "vendor_classification":"Vendor Classification",
      "previous_year":"Previous Year",
      "one_year_before_previous_year":"One Year Before Previous Year",
      "two_years_before_previous_year":"Two Years Before Previous Year",
      'primary_address.multiple_bank_detail.account_holder__registered_name': 'Account Holder Name',
      'primary_address.multiple_bank_detail.account_no': 'Account No',
      'primary_address.multiple_bank_detail.plant_code': 'Plant Code',
      'primary_address.multiple_bank_detail.bank_name': 'Bank Name',
      'primary_address.multiple_bank_detail.bank_address': 'Bank Address',
      "primary_address.multiple_bank_detail.ifsc_code": 'Ifsc Code',
      'primary_address.multiple_bank_detail.branch_name': 'Branch Name',
      'primary_address.multiple_bank_detail.bank_city': 'Bank City',
      "primary_address.multiple_bank_detail.bank_region": 'Bank Region',
      "primary_address.multiple_bank_detail.cancelled_cheque": 'Bank Document',
      "msme_no":"MSME No",
      "msme_expiry_year":"MSME Expiry Year",
      "msme_certificate":"MSME Certificate",
      "cin_no":"Cin No",
      "upload_cin":"CIN Document",
      "legal_name":"Legal Name",
      "tin_no":"Tin No",
      "aadhar_no":"Aadhar No",
      "din_no":"Din No",
      "company_registration":"Company Registration",
      "other_documents":"Other Documents",
      "evaluation_sheet":"Evaluation Sheet",
      "propertiery_img":"Profile Photo",
      "pan_document":"PAN Document",
      "document_1_name":"Company Profile",
      "document_1":"Company Profile Document",
      "document_2_name":"Balance Sheet",
      "document_2":"Balance Sheet",
      "document_3_name":"Auditor Report",
      "document_3":"Auditor Report",
      "document_4_name":"ISO Certificate ",
      "document_4":"ISO Certificate",
      "document_5_name":"List Of Equipment",
      "document_5":"List Of Equipment Document",
      "document_6_name":"Other",
      "document_6":"Other Document",
      "primary_address.address_type":"Address Type",
      "new_vm_contact_detail.vm_name": "VM Name",
      "new_vm_contact_detail.telephone": "Telephone",
      "new_vm_contact_detail.email_id": "Email ID",
      "new_vm_contact_detail.mobile_phone": "Mobile Phone",

      "new_rockman_contact_detail.first_name": "First Name",
      "new_rockman_contact_detail.last_name": "Last Name",
      "new_rockman_contact_detail.rockman_contact_department": "Department",
      "new_rockman_contact_detail.rockman_contact_function": "Function",

      // "new_vm_contact_detail.vm_name": "VM Name"
    };

    const dynamicKeyMatchForBank= longKey.match(/primary_address.multiple_bank_detail\.(\d+)\.(.+)/);
    if (dynamicKeyMatchForBank) {
      const index = dynamicKeyMatchForBank[1]; // e.g., "0" or "1"
      const subKey = dynamicKeyMatchForBank[2]; // e.g., "mobile_phone" or "vm_name"

      // Check if the subkey exists in the key map
      if (keyMap[`primary_address.multiple_bank_detail.${subKey}`]) {
        return `${index}: ${keyMap[`primary_address.multiple_bank_detail.${subKey}`]}`;
      }
    }

    const dynamicKeyForVM = longKey.match(/new_vm_contact_detail\.(\d+)\.(.+)/);
    if (dynamicKeyForVM) {
      const index = dynamicKeyForVM[1]; // e.g., "0" or "1"
      const subKey = dynamicKeyForVM[2]; // e.g., "mobile_phone" or "vm_name"

      // Check if the subkey exists in the key map
      if (keyMap[`new_vm_contact_detail.${subKey}`]) {
        return `${index}: ${keyMap[`new_vm_contact_detail.${subKey}`]}`;
      }
    }

    const dynamicKeyMatchForRC= longKey.match(/new_rockman_contact_detail\.(\d+)\.(.+)/);
    if (dynamicKeyMatchForRC) {
      const index = dynamicKeyMatchForRC[1]; // e.g., "0" or "1"
      const subKey = dynamicKeyMatchForRC[2]; // e.g., "mobile_phone" or "vm_name"

      // Check if the subkey exists in the key map
      if (keyMap[`new_rockman_contact_detail.${subKey}`]) {
        return `${index}: ${keyMap[`new_rockman_contact_detail.${subKey}`]}`;
      }
    }


    return keyMap[longKey] || null;
  }

  // getFilteredDetails() {
  //  this.bank_data=[]
  //  this.other_data=[]
  //   let final_data=[]
  //   if (this.highlights_detail && Array.isArray(this.highlights_detail)) {

  //     const data = this.highlights_detail.filter((detail: any) => this.getShortKey(detail.key));

  //     if (data.length > 0) {
  //       data.forEach((res: any) => {
  //         if (res.key.startsWith("primary_address.multiple_bank_detail")) {
  //           this.bank_data.push(res)
  //         }else{
  //            this.other_data.push(res)
  //         }
  //       });
  //     }

  //     if (this.is_purchase_approver_1 || this.isPurchase) {
  //       final_data=this.other_data
  //     }else if (this.is_finance_approver_2) {
  //       final_data=this.bank_data
  //     }else{
  //       final_data=[]
  //     }

  //     return final_data;
  //   } else {
  //     return [];
  //   }
  // }


  getFilteredDetails() {
    this.bank_data = [];
    this.other_data = [];

    if (!this.highlights_detail || !Array.isArray(this.highlights_detail)) {
      return [];
    }

    const filteredData = this.highlights_detail.filter((detail: any) => this.getShortKey(detail.key));

    filteredData.forEach((res: any) => {
      if (res.key.startsWith("primary_address.multiple_bank_detail")) {
        this.bank_data.push(res);
      } else {
        this.other_data.push(res);
      }
    });

    let resultData: any[] = [];
    const hasBankChanges = this.bank_data.length > 0;
    const hasOtherChanges = this.other_data.length > 0;

    if (hasBankChanges && hasOtherChanges) {
      if (this.is_purchase_approver_1 || this.isPurchase) {
        resultData = [...this.bank_data, ...this.other_data];
      } else if (this.is_finance_approver_2) {
        resultData = this.bank_data;
      }
    } else if (hasBankChanges && !hasOtherChanges) {
      if (this.is_purchase_approver_1 || this.isPurchase || this.is_finance_approver_2) {
        resultData = this.bank_data;
      }
    } else if (!hasBankChanges && hasOtherChanges) {
      if (this.is_purchase_approver_1 || this.isPurchase) {
        resultData = this.other_data;
      }
    }

    return resultData.sort((a, b) => {
      const aIndex = FIELD_ORDER.findIndex(field =>
        a.key.startsWith(field) || (field.includes('multiple_bank_detail') && a.key.includes('multiple_bank_detail'))
      );
      const bIndex = FIELD_ORDER.findIndex(field =>
        b.key.startsWith(field) || (field.includes('multiple_bank_detail') && b.key.includes('multiple_bank_detail'))
      );

      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;
      return 0;
    });
  }


  shouldHighlight(key: string): boolean {
      return this.highlights_detail && this.highlights_detail.some((detail: any) =>detail.key === key);
  }

  newVmHighlightClass(index: number, field: string): {[key: string]: boolean} {
    const key = `new_vm_contact_detail.${index}.${field}`;
    return {
      highlight: this.highlightStatus[key]
    };
  }

  RCHighlightClass(index: number, field: string): {[key: string]: boolean} {
    const key = `new_rockman_contact_detail.${index}.${field}`;
    return {
      highlight: this.highlightStatus[key]
    };
  }

  multipleBankHighlightClass(index: number, field: string): {[key: string]: boolean} {
    const key = `primary_address.multiple_bank_detail.${index}.${field}`;
    return {
      highlight: this.highlightStatus[key]
    };
  }


  openConfirmationDialog() {
    if (this.isPendingApproval2) {
      this.sidebarVisible=true
      this.isApproved=true
      this.isWithHoldingTaxYes=false
      this.withholdingtax=''
      this.accountgroup=''
      this.withHoldingMultiData =[]
    }else if (this.isAuditor && this.vendorAllDetail.status === "PENDING_APPROVER") {
      this.pendingApprovalForDialog=true
    }else if (this.is_purchase_approver_1 || this.is_finance_approver_2 || this.isPurchase) {
      this.pendingApprovalForDialog=true
    }
    else{
      this.isApproveDialog = true
      this.withholdingtax=''
    }
    }

    openSummaryDialog(){
      this.isDialogSummary=true
    }


  openRejectDialog() {
    if (this.isAuditor && this.vendorAllDetail.status === "PENDING_APPROVER") {
      this.pendingRejectForDialog=true
    } else if (this.is_purchase_approver_1 || this.is_finance_approver_2 || this.isPurchase) {
      this.pendingRejectForDialog=true
    }else
    {
      this.isRejectDialog = true
    }
  }
  openVendorQueryDialog(){
    this.is_need_Detail=true
  }

  isFormValid(): boolean {
    if (this.isPendingApproval1) {
      return this.paymentTerm !== '' && this.purchasingOrganization !== '' && this.newAccountGroup !== '';
    } else if (this.isPendingApproval2) {
      if (this.isSelectNo) {
        return true
      } else {
        return this.withholdingtax !== '' && this.accountgroup !== '' && this.reconciliationName !=='' && this.WithHoldingTaxType !=='' && this.WithHoldingTaxCodeName !==''  && this.Wthttype !== '' && this.Wtaxcode !== '' && this.RectyData !== '';
      }
      // return this.withholdingtax !== '';
    } else if (this.pendingreview) {
      return this.riskScore !== '' && this.evaluatedScore !== ''
    }else if(this.isPendingCPOApproval){
      return true
    }
    return false;
  }
  isFormValid1(): boolean {
   if (this.isPendingApproval2) {
    if (this.isSelectNo) {
      return this.accountgroup !== '' && this.withholdingtax !== '';
    } else {
      return this.withHoldingMultiData.length > 0 && this.accountgroup !== '' && this.withholdingtax !== '';
    }
  }
      // return this.withholdingtax !== '';
    return false;
  }
  isFormValid2(): boolean {
   if (this.isPendingApproval2) {
        return this.withholdingtax !== '' && this.reconciliationName !=='' && this.WithHoldingTaxType !=='' && this.WithHoldingTaxCodeName !==''  && this.Wthttype !== '' && this.Wtaxcode !== '' && this.RectyData !== '';
      }
      // return this.withholdingtax !== '';
    return false;
  }


  onUploadFile($event: any, type: string) {
    if ($event.files && $event.files.length > 0) {
      const file = $event.files[0];
      const fileUrl = `/private/files/${file.name}`;
      if (type === 'thrid_party_business_score_doc') {
        this.thrid_party_business_score_doc = file;
      } else if (type === 'thrid_party_evaluated_scorecard_doc') {
        this.thrid_party_evaluated_scorecard_doc = file;
      }
      // this.registrationForm.patchValue({
      //   [type]: fileUrl,
      // });

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: `${type} uploaded successfully`,
      });
    } else {
      console.error(`Please select a ${type}.`);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: `Please select a ${type}.`,
      });
    }
  }

  cancelUpload(type: string) {
    if (type === 'thrid_party_business_score_doc') {
      this.thrid_party_business_score_doc = null;
    } else if (type === 'thrid_party_evaluated_scorecard_doc') {
      this.thrid_party_evaluated_scorecard_doc = null;
    }
  }


  approvedVendor() {
    this.sidebarVisible = false
    this.confirmationService.close();
    this.isLoading = true
    const uploadPromises = [];
    if (this.thrid_party_business_score_doc) {
      const msmeArgs = {
        is_private: '1',
        folder: 'Home',
        file_url: `/private/files/${this.thrid_party_business_score_doc.name}`,
        doctype: 'Vendor Master',
        docname: this.PendingVendorDto!.business_name,
        fieldname: 'thrid_party_business_score_doc',
      };
      const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
      uploadPromises.push(
        this.vendorService
          .uploadFile(path, this.thrid_party_business_score_doc, msmeArgs)
          .toPromise()
      );
    }
    if (this.thrid_party_evaluated_scorecard_doc) {
      const msmeArgs1 = {
        is_private: '1',
        folder: 'Home',
        file_url: `/private/files/${this.thrid_party_evaluated_scorecard_doc.name}`,
        doctype: 'Vendor Master',
        docname: this.PendingVendorDto!.business_name,
        fieldname: 'thrid_party_evaluated_scorecard_doc',
      };
      const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
      uploadPromises.push(
        this.vendorService
          .uploadFile(path, this.thrid_party_evaluated_scorecard_doc, msmeArgs1)
          .toPromise()
      );
    }

    if (this.accountgroup != null && this.accountgroup != undefined) {
      this.PendingVendorDto!.account_group = this.accountgroup
    }
    if (this.paymentTerm != null && this.paymentTerm != undefined) {
      this.PendingVendorDto!.payment_term = this.paymentTerm
    }
    if (this.purchaseOrgannization != null && this.purchaseOrgannization != undefined) {
      this.PendingVendorDto!.purchase_organization = this.purchaseOrgannization
    }
    if (this.withholdingtax != null && this.withholdingtax != undefined) {
      this.PendingVendorDto!.with_holding_tax = this.withholdingtax
    }
    if (this.evaluatedScore != null && this.evaluatedScore != undefined) {
      this.PendingVendorDto!.evaluatedScore = this.evaluatedScore
    }
    if (this.riskScore != null && this.riskScore != undefined) {
      this.PendingVendorDto!.riskScore = this.riskScore
    }
    if (this.purchasingOrganization != null && this.purchasingOrganization != undefined) {
      this.PendingVendorDto!.purchase_organization = this.purchasingOrganization
    }
    if (this.newAccountGroup != null && this.newAccountGroup != undefined) {
      this.PendingVendorDto!.new_account_group = this.newAccountGroup
    }
    // if (this.ExemptionNumber != null && this.ExemptionNumber != undefined) {
    //   this.PendingVendorDto!.exemption_number = this.ExemptionNumber
    // }
    // if (this.Exem != null && this.Exem != undefined) {
    //   this.PendingVendorDto!.exem = this.Exem
    // }
    // if (this.ExemptFrom != null && this.ExemptFrom != undefined) {
    //   const formattedDate1 = this.datePipe.transform(this.ExemptFrom, 'yyyy-MM-dd');
    //   if (formattedDate1) {
    //     this.PendingVendorDto!.exempt_from = formattedDate1
    //   }
    // }
    // if (this.ExemptTo != null && this.ExemptTo != undefined) {
    //   const date1 = this.datePipe.transform(this.ExemptTo, 'yyyy-MM-dd');
    //   if (date1) {
    //     this.PendingVendorDto!.exempt_to = date1
    //   }
    // }
    if (this.thrid_party_business_score_doc != null && this.thrid_party_business_score_doc != undefined) {
      this.PendingVendorDto!.thrid_party_business_score_doc = `/private/files/${this.thrid_party_business_score_doc.name}`;
    }
    if (this.thrid_party_evaluated_scorecard_doc != null && this.thrid_party_evaluated_scorecard_doc != undefined) {
      this.PendingVendorDto!.thrid_party_evaluated_scorecard_doc = `/private/files/${this.thrid_party_evaluated_scorecard_doc.name}`;
    }
    if (this.withHoldingMultiData) {
      this.PendingVendorDto!.with_holding_list=this.withHoldingMultiData
    }
    this.vendorService.approve_vendors(this.PendingVendorDto).then((res) => {
      if (res.message.status == "Failed") {
        this.isLoading = false
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: res.message.message, life: 5000 });
        this.isApproveDialog = false
      } else {
        this.isLoading = false
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: res.message.message, life: 1000 });
        this.pendingreview ? (setTimeout(() => { this.router.navigate(['pending-review']) }, 1500)) : setTimeout(() => { this.router.navigate(['approve-vendor-list']) }, 1500)
        this.isVendorStatus = false
      }
      // this.messageService.add({ severity: 'success', summary: 'Successful', detail:res.message.message, life: 1000 });
    }).catch((error) => {
      this.isLoading = false
      console.log(error)
      this.closeConfirmationDialog()
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message.message });
    })
  }

  onReject() {
    this.confirmationService.close();
    this.isLoading = true
    this.PendingVendorDto!.reject_reason = this.rejectReason
    this.vendorService.reject_vendor(this.PendingVendorDto).then((res) => {
      if (res.message.status == "Failed") {
        this.isLoading = false
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: res.message.message, life: 5000 });
      } else {
        this.isLoading = false
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: res.message.message, life: 1000 });
        setTimeout(() => { this.router.navigate(['pending-review']) }, 1500)
      }
      this.isVendorStatus = false
    }).catch((error) => {
      console.log(error)
      this.isLoading = false
      this.closeConfirmationDialog()
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message.message });
    })
  }
  onApproveChangeRequest(){
    this.isLoading = true
    this.pendingApprovalForDialog=false
    this.vendorService.approve_vendor_change_detail(this.get_user).then((res)=>{
      if (res.message.status == "Failed") {
        this.isLoading = false
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: res.message.message, life: 5000 });
      } else {
        this.isLoading = false
        this.isVendorStatus = false
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: res.message.message, life: 1000 });
        setTimeout(() => { this.router.navigate(['pending-change-request']) }, 1500)
      }
    }).catch((error)=>{
      this.isLoading = false
      console.log(error)
    })
  }
  onRejectChangeRequest(){
    this.isLoading = true
    this.pendingRejectForDialog=false
    this.vendorService.reject_vendor_change_detail(this.get_user).then((res)=>{
      if (res.message.status == "Failed") {
        this.isLoading = false
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: res.message.message, life: 5000 });
      } else {
        this.isLoading = false
        this.isVendorStatus = false
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: res.message.message, life: 1000 });
        setTimeout(() => { this.router.navigate(['pending-change-request']) }, 1500)
      }
    }).catch((error)=>{
      this.isLoading = false
      console.log(error)
    })
  }
  onSubmitVendorQuery(){
    this.isLoading = true
    let data={
      get_user:this.get_user,
      remark_for_vendor_query:this.remark_for_vendor_query,
      headerStatus:this.headerStatus
    }
    this.is_need_Detail=false
    this.vendorService.create_vendor_query(data).then((res)=>{
      this.remark_for_vendor_query=''
      if (res.message.status == "Failed") {
        this.isLoading = false
        // this.is_need_Detail=false
        // this.remark_for_vendor_query=''
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: res.message.message, life: 5000 });
      } else {
        this.isLoading = false
        // this.isVendorStatus = false
        this.remark_for_vendor_query=''
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: res.message.message, life: 1000 });
        setTimeout(() => { this.router.navigate(['pending-change-request']) }, 1500)
      }
    }).catch((error)=>{
      this.isLoading = false
      console.log(error)
    })
  }

  closeConfirmationDialog() {
    this.accountgroup = ''
    this.paymentTerm = ''
    this.purchasingOrganization = ''
    this.newAccountGroup = ''
    this.purchaseOrgannization = ''
    this.withholdingtax = ''
    this.evaluatedScore = ''
    this.riskScore = ''
    this.thrid_party_business_score_doc = null
    this.thrid_party_evaluated_scorecard_doc = null
    this.confirmationService.close();
    this.isApproveDialog = false
    this.sidebarVisible = false
    this.Wthttype = ''
    this.Wtaxcode = ''
    this.RectyData = ''
    this.ExemptionNumber = ''
    this.Exem = ''
    this.ExemptFrom = undefined
    this.ExemptTo = undefined
    this.isWithHoldingTaxYes = false
  }
  onResetWithHolding(){
    this.Wthttype = ''
    this.Wtaxcode = ''
    this.RectyData = ''
    this.reconciliationName=''
    this.WithHoldingTaxType=''
    this.WithHoldingTaxCodeName=''
    this.ExemptionNumber = ''
    this.Exem = ''
    this.ExemptFrom = undefined
    this.ExemptTo = undefined
  }
  oncloseHolding(){
    this.Wthttype = ''
    this.Wtaxcode = ''
    this.withholdingtax=''
    this.accountgroup=''
    this.RectyData = ''
    this.reconciliationName=''
    this.WithHoldingTaxType=''
    this.WithHoldingTaxCodeName=''
    this.ExemptionNumber = ''
    this.Exem = ''
    this.ExemptFrom = undefined
    this.ExemptTo = undefined
    this.sidebarVisible = false
    this.withHoldingMultiData =[]
  }
  closeRejectDialog() {
    this.isRejectDialog = false
    this.rejectReason = ''
    this.confirmationService.close();
  }
  closeWithHoldingDialog() {
    this.isWithHoldingTaxYes = false
  }

  OnChangeWithholding(data: any) {
    if (data === 'Yes') {
      this.isWithHoldingTaxYes = true
      this.isSelectNo = false
      this.isApproved2=false
      this.sidebarVisible = true
      // this.isApproveDialog=false
      this.withHoldingMultiData =[]
      this.isApproved=true
    }
    if (data === 'No') {
      // this.sidebarVisible = false
      this.isApproved=false
      this.isSelectNo = true
      this.isApproved2=true
      this.isWithHoldingTaxYes = false
      this.accountgroup = ''
      this.paymentTerm = ''
      this.purchaseOrgannization = ''
      this.purchasingOrganization = ''
      this.newAccountGroup = ''
      this.reconciliationName=''
      this.WithHoldingTaxType=''
      this.WithHoldingTaxCodeName=''
      // this.withholdingtax = ''
      this.evaluatedScore = ''
      this.riskScore = ''
      this.Wthttype = ''
      this.Wtaxcode = ''
      this.RectyData = ''
      this.ExemptionNumber = ''
      this.Exem = ''
      this.ExemptFrom = undefined
      this.ExemptTo = undefined
      this.withHoldingMultiData =[]
      this.PendingVendorDto.reconciliation_type=''
      this.PendingVendorDto.with_holding_tax_code=''
      this.PendingVendorDto.with_holding_tax_type=''
    }
  }

  OnChangeReconciliation(data: any) {
    this.reconciliationName = data.type
    this.PendingVendorDto!.reconciliation_type = data.type
  }
  OnChangeWithholdingTaxCode(data: any) {
    this.WithHoldingTaxCodeName = data.tax_code
    this.PendingVendorDto!.with_holding_tax_code = data.tax_code
  }
  OnChangeWithholdingTaxType(data: any) {
    this.WithHoldingTaxType = data.tax_type
    this.PendingVendorDto!.with_holding_tax_type = data.tax_type
    this.WithHoldingTaxCodeName=''
    this.withHoldingTaxCode=[]
    // this.withHoldingTaxCode1.forEach((pt:any) => {
    //   if (pt.description === data.description1) {
    if (data.tax_code) {
      let pt1: WithHoldingTaxCode = {
        tax_code: data.tax_code,
        description: `${data.tax_code}-${data.descriptionMain}`
      };

      this.withHoldingTaxCode.push(pt1);
    }
    //   }
    // });
  }

  getSeverity(data: string): string {
    if (!data) {
      return 'info';
    }

    switch (data) {
      case 'PENDING_REVIEW':
        this.headerStatus = "Pending Review"
        return 'pendingreview';
      case 'PENDING_APPROVER':
        this.headerStatus = "Pending Approval"
        return 'pendingreview';
      case 'Draft':
        this.headerStatus = "Draft"
        return 'draft';
      case 'PENDING_APPROVER_1':
        this.headerStatus = "Pending For Department Approval"
        return 'pendingapproval1';
      case 'PENDING_APPROVER_2':
        this.headerStatus = "Pending For Final Approval"
        return 'pendingapproval2';
      case 'PENDING_CPO_APPROVAL':
        this.headerStatus = "CPO Approval"
        return 'cpo';
      case 'PURCHASE_APPROVER_1':
        this.headerStatus = "PURCHASE APPROVER 1"
        return 'cpo';
      case 'FINANCE_APPROVER_2':
        this.headerStatus = "FINANCE APPROVER 2"
        return 'cpo';
      case 'PENDING_PURCHASE':
        this.headerStatus = "PURCHASE APPROVER"
        return 'cpo';
      case 'APPROVED':
        this.headerStatus = "APPROVED"
        return 'approved';
      case 'REJECT':
        this.headerStatus = "REJECT"
        return 'REJECT';
      default:
        this.headerStatus = ""
        return 'info';
    }
  }


  // getSeverityClass(severity: string): string {
  //   switch (severity) {
  //     case 'approved':
  //       return 'approved';
  //     case 'pendingapproval2':
  //       return 'pendingapproval2';
  //     case 'pendingapproval1':
  //       return 'pendingapproval1';
  //     case 'draft':
  //       return 'draft';
  //     case 'pendingreview':
  //       return 'pendingreview';
  //     default:
  //       return '';
  //   }
  // }

  addWithholding(){
    const formattedDate1 = this.datePipe.transform(this.ExemptFrom, 'yyyy-MM-dd');
    const formattedDate2 = this.datePipe.transform(this.ExemptTo, 'yyyy-MM-dd');

    let withHoldingInterface: WithHoldingTaxDto = {
      reconciliation_type: this.RectyData.type,
      reconciliation_name:this.RectyData.description,
      with_holding_tax_type:this.Wthttype.tax_type,
      with_holding_tax_type_name:this.Wthttype.description,
      with_holding_tax_code:this.Wtaxcode.tax_code,
      with_holding_tax_code_name:this.Wtaxcode.description,
      exemption_number:this.ExemptionNumber,
      exem:this.Exem,
      exempt_from:formattedDate1 ? formattedDate1:'',
      exempt_to:formattedDate2 ? formattedDate2:''
    };
    this.withHoldingMultiData.push(withHoldingInterface)
    if (this.ExemptionNumber != null && this.ExemptionNumber != undefined) {
      this.PendingVendorDto!.exemption_number = this.ExemptionNumber
    }
    if (this.Exem != null && this.Exem != undefined) {
      this.PendingVendorDto!.exem = this.Exem
    }
    if (this.ExemptFrom != null && this.ExemptFrom != undefined) {
      const formattedDate1 = this.datePipe.transform(this.ExemptFrom, 'yyyy-MM-dd');
      if (formattedDate1) {
        this.PendingVendorDto!.exempt_from = formattedDate1
      }
    }
    if (this.ExemptTo != null && this.ExemptTo != undefined) {
      const date1 = this.datePipe.transform(this.ExemptTo, 'yyyy-MM-dd');
      if (date1) {
        this.PendingVendorDto!.exempt_to = date1
      }
    }

    if (this.withHoldingMultiData.length > 0 && this.accountgroup !== '') {
      this.isApproved=false
    }
    this.onResetWithHolding()
  }



  generateYearList(): void {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 10;
    const endYear = currentYear + 10;

    for (let year = startYear; year <= endYear; year++) {
      // this.msmeYearList.push(year);
      this.msmeYearList.push({ name: `Year ${year}`, year: year });
    }
  }

  onMsmeExpiryYearChange(event: any) {
    const currentYear = new Date().getFullYear();
    if (event >= currentYear) {
      this.enableMSMEUploadButton = false
    } else {
      this.enableMSMEUploadButton = true
    }
    if (event < currentYear) {
      this.enableMSMEYearInvalidMessage = true
    } else {
      this.enableMSMEYearInvalidMessage = false
    }
  }

  getPlantLabel(plant: string): any {
    const plantName = this.plantList.find((p) => p.plant__code == plant)
    return plantName.plant__code
  }

  updateGstnValidators(value: string): void {
    const gstnControl = this.registrationForm.get('primary_address.tax_details.gstn');

    if (value === 'Yes') {
      gstnControl?.setValidators([Validators.required, this.gstnValidator]);
      this.isDisablePan = true
    } else {
      gstnControl?.clearValidators();
      this.isDisablePan = false
      this.registrationForm.get('pan_no')?.setValue('');
    }
    gstnControl?.updateValueAndValidity(); // Update validity immediately
  }

  // getCity(city: string): any {
  //   const city1= this.cityAndStateList.find((p) => p.city && p.city.toUpperCase() === city.toUpperCase())
  //   if (city1) {
  //     return city1.city.toUpperCase();
  //   }else{
  //     return city
  //   }
  // }

  onGstnBlur(gstn: FocusEvent) {
    const gstnValue = (gstn.target as HTMLInputElement).value;
    const panNo = gstnValue.substring(2, 12);
    if (panNo) {
      this.registrationForm.get('pan_no')?.setValue(panNo)
    }

  }
    fetchVendorDetails(vendorDetail:any) {

     this.vendorService.getVendorById(vendorDetail).then((vendorDetails: any) => {
      this.vendorAllDetail=vendorDetails.message
      this.vendor_query_remark=vendorDetails.message?.vendor_query
      this.propertiery_img = vendorDetails.message?.propertiery_img;
      this.business_name=vendorDetails.message?.business_name
      this.get_user=vendorDetails.message?.get_user
      if (this.business_name) {
        this.PendingVendorDto!.business_name=this.business_name
      }
      if (this.get_user) {
        this.PendingVendorDto!.get_user=this.get_user
      }
      this.status=vendorDetails.message?.status
      if (vendorDetails.message?.primary_address?.country === 'IN') {
        this.onStateChange('IN')
        // const stateVal= vendorDetails.message?.primary_address?.state ? vendorDetails.message?.primary_address?.state:''
        // this.getStateLabel(stateVal, vendorDetails.message?.primary_address?.country, vendorDetails.message?.primary_address?.city)
      }

      if(vendorDetails.message?.select_industry_type) {
        this.SelectIndustryType1(vendorDetails.message?.select_industry_type)
      }

      if (vendorDetails.message.highlights_detail && vendorDetails.message?.status =="PURCHASE_APPROVER_1" || vendorDetails.message?.status =="FINANCE_APPROVER_2" || vendorDetails.message?.status =="PENDING_PURCHASE") {
        this.highlights_detail = JSON.parse(vendorDetails.message.highlights_detail);
        this.updateSummaryDetail(this.highlights_detail,vendorDetails.message?.primary_address?.city,vendorDetails.message?.primary_address?.state)

        this.updateHighlightStatus(vendorDetails.message?.status,this.highlights_detail);
      }
      if (vendorDetails.message.thrid_party_evaluated_score) {
        this.registrationForm.get('thrid_party_evaluated_score')?.setValue(vendorDetails.message.thrid_party_evaluated_score)
      }
      if (vendorDetails.message.thrid_party_risk_score) {
        this.registrationForm.get('thrid_party_risk_score')?.setValue(vendorDetails.message.thrid_party_risk_score)
      }


     this.formValues = {
        vendor_code: vendorDetails.message?.vendor_code || '',
        new_rockman_contact_detail:'',
        new_vm_contact_detail:'',
        // plant: vendorDetails.message?.plant || '',
        plant: vendorDetails.message?.plant ? this.getPlantLabel(vendorDetails.message?.plant): '',
        note: vendorDetails.note || '',
        company_title: vendorDetails.message?.company_title || '',
        ministry_of_corporate_affairsmca: vendorDetails.message?.ministry_of_corporate_affairsmca || '',
        mca_number: vendorDetails.message?.mca_number || '',
        select_industry_type: vendorDetails.message?.select_industry_type || '',
        gst_registered: vendorDetails.message?.gst_registered || '',
        vendor_type: vendorDetails.message?.vendor_type || '',
        business_name: vendorDetails.message?.business_name || '',
        vendor_classification: vendorDetails.message?.vendor_classification || '',
        short_name: vendorDetails.message?.short_name || '',
        // status: vendorDetails.message?.status || 'PENDING_REVIEW',
        previous_year: vendorDetails.message?.previous_year || '',
        one_year_before_previous_year: vendorDetails.message?.one_year_before_previous_year || '',
        two_years_before_previous_year: vendorDetails.message?.two_years_before_previous_year || '',
        financial_previous_year: vendorDetails.message?.financial_previous_year || '',
        financial_one_year_before_previous_year: vendorDetails.message?.financial_one_year_before_previous_year || '',
        financial_two_years_before_previous_year: vendorDetails.message?.financial_two_years_before_previous_year || '',
        legal_name: vendorDetails.message?.legal_name || '',
        pan_no: vendorDetails.message?.pan_no || '',
        cin_no: vendorDetails.message?.cin_no || '',
        tin_no: vendorDetails.message?.tin_no || '',
        din_no: vendorDetails.message?.din_no || '',
        msme_no: vendorDetails.message?.msme_no || '',
        msme_expiry_year: vendorDetails.message?.msme_expiry_year ?  this.getExpiryYear(vendorDetails.message?.msme_expiry_year) : '',
        aadhar_no: vendorDetails.message?.aadhar_no || '',
        msme_certificate: vendorDetails.message?.msme_certificate || '',
        mca_document: vendorDetails.message?.mca_document || '',
        company_registration: vendorDetails.message?.company_registration || '',
        other_documents: vendorDetails.message?.other_documents || '',
        pan_document: vendorDetails.message?.pan_document || '',
        propertiery_img: vendorDetails.message?.propertiery_img || '',
        upload_cin: vendorDetails.message?.upload_cin || '',
        self_declaration_by_vendor: vendorDetails.message?.self_declaration_by_vendor || '',
        evaluation_sheet: vendorDetails.message?.evaluation_sheet || '',
        document_1: vendorDetails.message?.document_1 || '',
        document_2: vendorDetails.message?.document_2 || '',
        document_3: vendorDetails.message?.document_3 || '',
        document_4: vendorDetails.message?.document_4 || '',
        document_5: vendorDetails.message?.document_5 || '',
        document_6: vendorDetails.message?.document_6 || '',
        document_1_name: vendorDetails.message?.document_1_name || '',
        document_2_name: vendorDetails.message?.document_2_name || '',
        document_3_name: vendorDetails.message?.document_3_name || '',
        document_4_name: vendorDetails.message?.document_4_name || '',
        document_5_name: vendorDetails.message?.document_5_name || '',
        document_6_name: vendorDetails.message?.document_6_name || '',
        get_user: vendorDetails.message?.get_user || '',
        primary_address: {
          address_title: vendorDetails.message?.primary_address?.address_title || '',
          address_line_1: vendorDetails.message?.primary_address?.address_line_1 || '',
          address_line_2: vendorDetails.message?.primary_address?.address_line_2 || '',
          city: vendorDetails.message?.primary_address?.city || '',
          country: vendorDetails.message?.primary_address?.country || '',
          state: this.getStateLabel(vendorDetails.message?.primary_address?.state, vendorDetails.message?.primary_address?.country) || '',
          postal_code: vendorDetails.message?.primary_address?.postal_code || '',
          email_address: vendorDetails.message?.primary_address?.email_address || '',
          phone_no: vendorDetails.message?.primary_address?.phone_no || '',
          fax: vendorDetails.message?.primary_address?.fax || '',
          address_summary: vendorDetails.message?.primary_address?.address_summary || '',
          address_type: vendorDetails.message?.primary_address?.address_type || '',
          preferred_billing_address: vendorDetails.message?.primary_address?.preferred_billing_address || '',
          preferred_shipping_address: vendorDetails.message?.primary_address?.preferred_shipping_address || '',
          disabled: vendorDetails.message?.primary_address?.disabled || '',
          is_primary: vendorDetails.message?.primary_address?.is_primary || '',
          contact_person: {
            name1: vendorDetails.message?.primary_address?.contact_person?.name1 || '',
            phone_no: vendorDetails.message?.primary_address?.contact_person?.phone_no || '',
            mobile_no: vendorDetails.message?.primary_address?.contact_person?.mobile_no || '',
            e_mail_id: vendorDetails.message?.primary_address?.contact_person?.e_mail_id || '',
            website_url: vendorDetails.message?.primary_address?.contact_person?.website_url || '',
            alternate_email_id: vendorDetails.message?.primary_address?.contact_person?.alternate_email_id || ''
          },
          // bank_detail: {
          //   account_holder__registered_name: vendorDetails.message?.primary_address?.bank_detail?.account_holder__registered_name || '',
          //   account_no: vendorDetails.message?.primary_address?.bank_detail?.account_no || '',
          //   bank_name: vendorDetails.message?.primary_address?.bank_detail?.bank_name || '',
          //   bank_address: vendorDetails.message?.primary_address?.bank_detail?.bank_address || '',
          //   ifsc_code: vendorDetails.message?.primary_address?.bank_detail?.ifsc_code || '',
          //   cancelled_cheque: vendorDetails.message?.primary_address?.bank_detail?.cancelled_cheque || '',
          //   branch_name: vendorDetails.message?.primary_address?.bank_detail?.branch_name || '',
          //   bank_city: vendorDetails.message?.primary_address?.bank_detail?.bank_city || '',
          //   bank_region: vendorDetails.message?.primary_address?.bank_detail?.bank_region || ''
          // },
          tax_details: {
            gstn: vendorDetails.message?.primary_address?.tax_details?.gstn || '',
            vat_registration_number: vendorDetails.message?.primary_address?.tax_details?.vat_registration_number || '',
            service_tax_registration_number: vendorDetails.message?.primary_address?.tax_details?.service_tax_registration_number || '',
            upload_gst: vendorDetails.message?.primary_address?.tax_details?.upload_gst || ''
          }
        }
      };

      this.registrationForm.patchValue(this.formValues);
      const contactsFormArray = this.rockmancontactForm.get('rockmancontacts') as FormArray;

      contactsFormArray.clear();
      const existingContacts = new Set<string>();

      if (vendorDetails.message?.contact_list && vendorDetails.message.contact_list.some((contact: any) =>
  contact.first_name || contact.last_name || contact.rockman_contact_department || contact.rockman_contact_function)) {
        vendorDetails.message.contact_list.forEach((contact: any) => {
          const firstName = contact.first_name || '';
          const lastName = contact.last_name || '';
          const department = contact.rockman_contact_department || '';
          const functionValue = contact.rockman_contact_function || '';
          const uniqueKey = `${firstName}-${lastName}-${department}-${functionValue}`;

          if ((firstName || lastName || department || functionValue) && (!existingContacts.has(uniqueKey))) {
            contactsFormArray.push(this.fb.group({
              first_name: [firstName, Validators.required],
              last_name: [lastName, Validators.required],
              rockman_contact_department: [department, Validators.required],
              rockman_contact_function: [functionValue, Validators.required]
            }));
            existingContacts.add(uniqueKey);
          }
        });
      } else {
        contactsFormArray.push(this.fb.group({
          first_name: ['', Validators.required],
          last_name: ['', Validators.required],
          rockman_contact_department: ['', Validators.required],
          rockman_contact_function: ['', Validators.required]
        }));
      }


      const rockmanContactsFormArray = this.contactForm.get('contacts') as FormArray;

      rockmanContactsFormArray.clear();
      const existingVMContacts = new Set<string>();
      if (vendorDetails.message?.vm_contact_list && vendorDetails.message.vm_contact_list.some((vm_contacts: any) =>
      vm_contacts.vm_name || vm_contacts.telephone || vm_contacts.mobile_phone || vm_contacts.email_id)){
        vendorDetails.message.vm_contact_list.forEach((vmContact: any) => {
          const vmName = vmContact.vm_name || '';
          const telephone = vmContact.telephone || '';
          const mobilePhone = vmContact.mobile_phone || '';
          const emailId = vmContact.email_id || '';
          const uniqueKey = `${vmName}-${telephone}-${mobilePhone}-${emailId}`;

          if ((vmName || telephone || mobilePhone || emailId ) && (!existingVMContacts.has(uniqueKey))) {
            rockmanContactsFormArray.push(this.fb.group({
              vm_name: [vmName],
              telephone: [telephone, Validators.required],
              mobile_phone: [mobilePhone, Validators.required],
              email_id: [emailId, Validators.required]
            }));
            existingVMContacts.add(uniqueKey);
          }
        });
      } else {
        rockmanContactsFormArray.push(this.fb.group({
          vm_name: [''],
          telephone: ['', Validators.required],
          mobile_phone: ['', Validators.required],
          email_id: ['', Validators.required]
        }));
      }

      const banksFormArray = this.multipleBankDetailForm.get('multipleBank') as FormArray;

      banksFormArray.clear();
      this.patchBankUploaded = []

      const existingbanks = new Set<string>();

      if (vendorDetails.message?.multiple_bank_detail_fetched && vendorDetails.message.multiple_bank_detail_fetched.length > 0) {
        vendorDetails.message.multiple_bank_detail_fetched.forEach((bank: any) => {
          const account_holder__registered_name = bank.account_holder__registered_name || '';
          const account_no = bank.account_no || '';
          const ifsc_code = bank.ifsc_code || '';
          const plant_code = bank.plant_code || '';
          const bank_name = bank.bank_name || '';
          const bank_address = bank.bank_address || '';
          const branch_name = bank.branch_name || '';
          const bank_city = bank.bank_city || '';
          const bank_region = bank.bank_region || '';
          const cancelled_cheque = bank.cancelled_cheque || '';
          const uniqueKey = `${account_holder__registered_name}-${account_no}-${ifsc_code}`;

          if ((account_holder__registered_name || plant_code || account_no || ifsc_code || bank_name ||bank_address ||branch_name || bank_city||bank_region || cancelled_cheque) && (!existingbanks.has(uniqueKey))) {
            banksFormArray.push(this.fb.group({
              account_holder__registered_name: [account_holder__registered_name],
              account_no: [account_no],
              plant_code: [this.bankPlantCodeToName(plant_code)],
              bank_name: [bank_name],
              bank_address: [bank_address],
              ifsc_code: [ifsc_code],
              cancelled_cheque: [cancelled_cheque],
              branch_name: [branch_name],
              bank_city: [bank_city], // Add bank_city here
              bank_region: [bank_region], // Add bank_region here
            }));
            existingbanks.add(uniqueKey);
          }
          this.patchBankUploaded = vendorDetails.message?.multiple_bank_detail_fetched.map((bank: any) => ({
            account_holder__registered_name: bank.account_holder__registered_name || '',
            account_no: bank.account_no || '',
            ifsc_code: bank.ifsc_code || '',
            plant_code: bank.plant_code || '',
            bank_name: bank.bank_name || '',
            bank_address: bank.bank_address || '',
            branch_name: bank.branch_name || '',
            bank_city: bank.bank_city || '',
            bank_region: bank.bank_region || '',
            cancelled_cheque: bank.cancelled_cheque || ''
          }));

        });
      } else {
        banksFormArray.push(this.fb.group({
          account_holder__registered_name: [''],
          account_no: [''],
          plant_code: [''],
          bank_name: [''],
          bank_address: [''],
          ifsc_code: [''],
          cancelled_cheque: [''],
          branch_name: [''],
          bank_city: [''], // Add bank_city here
          bank_region: [''], // Add bank_region here
        }));
      }
      banksFormArray.disable();
      if (vendorDetails.message.status === "PENDING_ADMIN_APPROVAL") {
        this.isVendorStatus = true
      }
      if (vendorDetails.message.status === "PENDING_APPROVER_1") {
        this.isPendingApproval1 = true
        this.isVendorStatus = true
      }
      if (vendorDetails.message.status === "PENDING_APPROVER_2") {
        this.isPendingApproval2 = true
        this.isVendorStatus = true
      }
      if (vendorDetails.message.status === "PENDING_REVIEW") {
        this.pendingreview = true
        this.isVendorStatus = true
      }
      if (vendorDetails.message.status === "APPROVED") {
          this.isFinalApproved=true
      }
      if (vendorDetails.message.status === "PURCHASE_APPROVER_1") {
        this.isVendorStatus = true
        this.is_purchase_approver_1 = true
      }
      if (vendorDetails.message.status === "FINANCE_APPROVER_2") {
        this.isVendorStatus = true
        this.is_finance_approver_2 = true
      }
      if (vendorDetails.message.status === "PENDING_PURCHASE") {
        this.isVendorStatus = true
        this.isPurchase = true
      }
      if (vendorDetails.message.status === "PENDING_CPO_APPROVAL") {
        this.isVendorStatus = true
        this.isPendingCPOApproval = true
      }
      if (this.isAuditor && vendorDetails.message.status === "PENDING_APPROVER") {
        this.isVendorStatus = true
        this.isAuditorApprovalForChange=true
      }
      this.selectedVendorList.push(vendorDetails.message.business_name)

      this.thridPartyScoreDocuments = [
        { name: '3rd Party Business Score Doc', file: vendorDetails.message.thrid_party_business_score_doc },
        { name: '3rd Party Evaluated Scorecard Doc', file: vendorDetails.message.thrid_party_evaluated_scorecard_doc },
      ]

      this.formValues.new_rockman_contact_detail=contactsFormArray.value
      this.formValues.new_vm_contact_detail=rockmanContactsFormArray.value
      this.formValues.multiple_bank_detail=banksFormArray.value

      this.evaluationSheetUrl = vendorDetails.message?.evaluation_sheet || '';
      this.document1Url = vendorDetails.message?.document_1 || '';
      this.document2Url = vendorDetails.message?.document_2 || '';
      this.document3Url = vendorDetails.message?.document_3 || '';
      this.document4Url = vendorDetails.message?.document_4 || '';
      this.document5Url = vendorDetails.message?.document_5 || '';
      this.document6Url = vendorDetails.message?.document_6 || '';
      this.msme_certificateUrl = vendorDetails.message?.msme_certificate || '';
      this.company_registrationUrl = vendorDetails.message?.company_registration || '';
      this.other_documentsUrl = vendorDetails.message?.other_documents || '';
      this.upload_cinUrl = vendorDetails.message?.upload_cin || '';
      this.propertiery_imgUrl = vendorDetails.message?.propertiery_img || '';
      this.mca_documentUrl = vendorDetails.message?.mca_document || '';
      this.self_declaration_by_vendorUrl = vendorDetails.message?.self_declaration_by_vendor || '';
      this.pan_documentUrl = vendorDetails.message?.pan_document || '';
      this.upload_gstUrl = vendorDetails.message?.primary_address?.tax_details?.upload_gst  || '';
      this.cancelled_chequeUrl = vendorDetails.message?.primary_address?.bank_detail?.cancelled_cheque || '';
      this.riskScore_doc = vendorDetails.message.thrid_party_business_score_doc || '';
      this.evaluatedScore_doc = vendorDetails.message.thrid_party_evaluated_scorecard_doc || '';
    }).catch(error => {
      console.error('Error fetching vendor details:', error);
    });
  }

  bankPlantCodeToName(plant_code:string):string{
    if(plant_code !=null || plant_code !=undefined){
      const bank_name=this.bankPlantNameAndCode.find(b=> b.value === plant_code)
      if(bank_name!=null || bank_name!=undefined){
        return bank_name.label
      }
    }
    return ""
  }

  updateSummaryDetail(highlights_detail:any,city:string,state:string){
    const vmContactDetailPattern = /^new_vm_contact_detail\.\d+$/;
    const rContactDetailPattern = /^new_rockman_contact_detail\.\d+$/;
    const multiple_bank_detailPattern = /^primary_address.multiple_bank_detail\.\d+$/;
    highlights_detail.forEach((data:any)=>{
      if (data.key === "primary_address.state") {
          // data.oldValue=data.oldValue
          if (data.newValue) {
            const newValue=this.state.find(s=> s.value === data.newValue)
            if (newValue) {
              data.newValue=newValue?.label
            }
          }
          if (data.oldValue) {
            const oldValue=this.state.find(s=> s.value === data.oldValue)
            if (oldValue) {
              data.oldValue=oldValue?.label
            }
          }
      }
      if (data.key === "primary_address.city") {
          // data.oldValue=data.oldValue
          if (data.newValue) {
            const newValue=this.cityAndStateList.find(s=> s.city && s.city.toUpperCase() === data.newValue.toUpperCase())
            if (newValue) {
              data.newValue=newValue?.city
            }
          }
          if (data.oldValue) {
            const oldValue=this.cityAndStateList.find(s=> s.city && s.city.toUpperCase() === data.oldValue.city.toUpperCase())
            if (oldValue) {
              data.oldValue=oldValue?.city
            }
          }
      }
      if (data.key === "primary_address.country") {
          if (data.newValue) {
            const newValue=this.countries_List.find(s=> s.value === data.newValue)
            data.newValue=newValue?.label
          }
          if (data.oldValue) {
            const oldValue=this.countries_List.find(s=> s.value === data.oldValue)
            data.oldValue=oldValue?.label
          }
      }
      if (data.key === "plant") {
        if (data.newValue) {
          const newValue=this.plantList.find(s=> s.plant__code === data.newValue)
          data.newValue=newValue?.name1
        }
        if (data.oldValue) {
          const oldValue=this.plantList.find(s=> s.plant__code === data.oldValue)
          data.oldValue=oldValue?.name1
        }
    }


      if (vmContactDetailPattern.test(data.key)) {
        const keyPrefix = data.key.split('.')[0]; // "new_vm_contact_detail"
        const index = data.key.split('.')[1]; // "2"

        if (data.newValue) {
          Object.keys(data.newValue).forEach(property => {
            highlights_detail.push({
              key: `${keyPrefix}.${index}.${property}`,
              newValue: data.newValue[property]
            });
          });
        }
      }
      if (rContactDetailPattern.test(data.key)) {
        const keyPrefix = data.key.split('.')[0]; // "new_vm_contact_detail"
        const index = data.key.split('.')[1]; // "2"

        if (data.newValue) {
          Object.keys(data.newValue).forEach(property => {
            highlights_detail.push({
              key: `${keyPrefix}.${index}.${property}`,
              newValue: data.newValue[property]
            });
          });
        }
      }
      // if (multiple_bank_detailPattern.test(data.key)) {
      //   const keyPrefix = data.key.split('.')[0]; // "new_vm_contact_detail"
      //   const index = data.key.split('.')[1]; // "2"

      //   if (data.newValue) {
      //     Object.keys(data.newValue).forEach(property => {
      //       highlights_detail.push({
      //         key: `${keyPrefix}.${index}.${property}`,
      //         newValue: data.newValue[property]
      //       });
      //     });
      //   }
      // }
      if (multiple_bank_detailPattern.test(data.key)) {
        const keyParts = data.key.split('.');  // Splits the key into parts
        const keyPrefix = keyParts.slice(0, -1).join('.');  // "primary_address.multiple_bank_detail"
        const index = keyParts[keyParts.length - 1];  // "1"

        if (data.newValue) {
          Object.keys(data.newValue).forEach(property => {
            highlights_detail.push({
              key: `${keyPrefix}.${index}.${property}`,  // Builds the key dynamically
              newValue: data.newValue[property]
            });
          });
        }
    }
    });
  }

//   updateHighlightStatus(status:string,highlights_detail:any): void {
//     debugger
//   if (status == "PURCHASE_APPROVER_1" || status == "FINANCE_APPROVER_2" || status == "PENDING_PURCHASE") {
//     highlights_detail.forEach((data:any)=>{
//       // if (data.key.startsWith("primary_address.multiple_bank_detail") && status == "FINANCE_APPROVER_2") {
//       //   this.highlightStatus[data.key] = this.shouldHighlight(data.key);
//       // }
//       if ( (status == "PURCHASE_APPROVER_1" || status == "FINANCE_APPROVER_2") && !data.key.startsWith("primary_address.multiple_bank_detail")) {
//         this.highlightStatus[data.key] = this.shouldHighlight(data.key);
//       }
//     })
// }
// }
    ismca(): boolean {
    return (
      this.registrationForm.get('ministry_of_corporate_affairsmca')?.value ===
      'Yes'
    );
  }

  updateHighlightStatus(status: string, highlights_detail: any): void {
    highlights_detail.forEach((data: any) => {
      if (
        (status === "PURCHASE_APPROVER_1" || status === "PENDING_PURCHASE")
      ) {
        this.highlightStatus[data.key] = this.shouldHighlight(data.key);
      } else if (
        status === "FINANCE_APPROVER_2" &&
        data.key.startsWith("primary_address.multiple_bank_detail")
      ) {
        this.highlightStatus[data.key] = this.shouldHighlight(data.key);
      }
    });
  }


  getStateLabel(value: string, country: any): any {
    const stateObj = this.state.find(s => s.value === value);
    if (country === 'IN' && stateObj) {
      return stateObj?.label
    } else {
      return value
    }
  }

  // getStateLabel(value: string, country: any,city:string): any {
  //   // const stateObj = this.cityAndStateList.find(s => s.state_code === value && s.city === city);
  //   if (country === 'IN' && city && value) {
  //     // Convert city to uppercase for case-insensitive comparison, only if it's a valid string
  //     const cityUpper = city ? city.toUpperCase() : ''; // Handle null/undefined city gracefully

  //     // Build the lookup map with uppercase city comparison, checking if item.city exists
  //     const lookupMap = this.cityAndStateList.reduce((map, item) => {
  //       if (item.city) { // Ensure item.city is not null or undefined
  //         const key = `${item.state_code}_${item.city.toUpperCase()}`;
  //         map[key] = item;
  //       }
  //       return map;
  //     }, {});

  //     const key = `${value}_${cityUpper}`; // Use uppercase city in key
  //     const stateObj = lookupMap[key];
  //     return stateObj?.state;
  //   } else if (country === 'IN' && (city === "" || city == null || city == undefined)) {
  //     const stateObj1 = this.state.find(s => s.value === value);
  //     return stateObj1?.label;
  //   } else {
  //     return value;
  //   }
  // }
  getExpiryYear(year:number): any {
    const obj = this.msmeYearList.find(item => item.year === Number(year));
    return obj.year;
  }


  get contacts(): FormArray {
    return this.contactForm.get('contacts') as FormArray;
  }

  get rockmancontacts(): FormArray {
    return this.rockmancontactForm.get('rockmancontacts') as FormArray;
  }

  // addContact() {
  //   const contactsArray = this.contactForm.get('contacts') as FormArray;
  //   const newContact = this.fb.group({
  //     vm_name: ['', Validators.required],
  //     telephone: ['', [Validators.required, Validators.pattern(/^\d{10,15}$/)]],
  //     email_id: ['', [Validators.required, Validators.email]],
  //     mobile_phone: ['', [Validators.required, Validators.pattern(/^\d{10,15}$/)]],
  //   });

  //   contactsArray.push(newContact);
  //   this.noContacts = false;
  // }

  removeContact(index: number) {
    const contactsArray = this.contactForm.get('contacts') as FormArray;
    // contactsArray.removeAt(index);
    if (contactsArray.length > 1) {
      contactsArray.removeAt(index);
    }
    this.noContacts = contactsArray.length === 0;
  }

  saveAllContacts() {
    if (this.contactForm) {
      const contacts = this.contactForm.value.contacts;

    } else {
      console.error('Invalid contact data. Cannot save or update');
      this.messageService.add({ severity: 'error', summary: this.content, detail: 'Invalid contact data. Cannot save or update' });
    }
  }

  // addRockmanContact() {
  //   const rockmancontactsArray = this.rockmancontactForm.get('rockmancontacts') as FormArray;
  //   const newRockmanContact = this.fb.group({
  //     first_name: [''],
  //     last_name: [''],
  //     rockman_contact_department: [''],
  //     rockman_contact_function: [''],
  //   });

  //   rockmancontactsArray.push(newRockmanContact);
  //   this.noRockmanContacts = false;
  // }

  removeRockmanContact(index: number) {
    const rockmancontactsArray = this.rockmancontactForm.get('rockmancontacts') as FormArray;
    // rockmancontactsArray.removeAt(index);
    if (rockmancontactsArray.length > 1) {
      rockmancontactsArray.removeAt(index);
    }
    this.noRockmanContacts = rockmancontactsArray.length === 0;
  }
  noSpecialCharactersValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const regex = /^[a-zA-Z0-9]+$/; // Regex to allow only alphanumeric characters

      if (control.value && !regex.test(control.value)) {
        return { 'specialCharacters': true };
      }

      return null;
    };
  }
  downloadFile(url: string, fileName: string): void {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement('a');

        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(error => console.error('Error downloading file:', error));
  }

  downloadFileForBanks(index: number, fileName: string): void {
    const data = this.patchBankUploaded[index]
    if(data && data.cancelled_cheque){
      fetch(data.cancelled_cheque)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement('a');

        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(error => console.error('Error downloading file:', error));
    }
  }
  // downloadEvaluationSheetFormat () {
  //   this.router.navigate("http://127.0.0.1:8000/files/evaluation_sheet_format.xlsx")=
  // }

  panValidator(control: AbstractControl): ValidationErrors | null {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

    if (control.value && !panRegex.test(control.value)) {
      return { invalidPan: true };
    }

    return null;
  }

  gstnValidator(control: AbstractControl): ValidationErrors | null {
    const gstnRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9A-Z]{1}$/;

    if (control.value && !gstnRegex.test(control.value)) {
      return { invalidGstn: true };
    }

    return null;
  }

  onGstnInput(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace'];
    const allowedCharacters = /^[0-9A-Z]$/i; // Regex for allowing digits (0-9) and letters (A-Z) case insensitive

    if (!allowedKeys.includes(event.key) && !allowedCharacters.test(event.key)) {
      event.preventDefault();
      return;
    }

    const input = event.target as HTMLInputElement;
    if (input.value.length >= 15 && event.key !== 'Backspace') {
      event.preventDefault();
    }
  }
  onPanNoInput(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace'];
    const allowedCharacters = /^[0-9A-Z]$/i; // Regex for allowing digits (0-9) and letters (A-Z) case insensitive

    if (!allowedKeys.includes(event.key) && !allowedCharacters.test(event.key)) {
      event.preventDefault();
      return;
    }

    const input = event.target as HTMLInputElement;
    if (input.value.length >= 10 && event.key !== 'Backspace') {
      event.preventDefault();
    }
  }



  validatePostalCode(event: KeyboardEvent) {
    const key = event.key;
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'];
    const isNumeric = /[0-9]/.test(key);

    if (!isNumeric && !allowedKeys.includes(key)) {
      event.preventDefault();
    }

    // Limit to 6 digits
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length >= 6 && !allowedKeys.includes(key)) {
      event.preventDefault();
    }
  }

  validateIFSCCode(event: KeyboardEvent) {
    // Get the current value of the input field
    const key = event.key;
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'];
    const allowedCharacters = /^[0-9A-Z]$/i; // Regex for allowing digits (0-9) and letters (A-Z) case insensitive


    if (!allowedCharacters && !allowedKeys.includes(key)) {
      event.preventDefault();
    }

    // Limit to 11 digits
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length >= 11 && !allowedKeys.includes(key)) {
      event.preventDefault();
    }
  }


  updateMobileNoCode(event: any) {
    if (event.value) {
      this.registrationForm
        .get('primary_address')
        ?.get('contact_person')
        ?.patchValue({
          mobile_no: event.value,
        });
    }
  }
  validateAadharNumber(event: KeyboardEvent) {
    const key = event.key;
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'];
    const isNumeric = /[0-9]/.test(key);

    if (!isNumeric && !allowedKeys.includes(key)) {
      event.preventDefault();
    }

    // Limit to 12 digits
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length >= 12 && !allowedKeys.includes(key)) {
      event.preventDefault();
    }
  }
  validateIfcsCode(event: KeyboardEvent) {
    const key = event.key;
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'];
    const isNumeric = /[0-9]/.test(key);

    if (!isNumeric && !allowedKeys.includes(key)) {
      event.preventDefault();
    }

    // Limit to 12 digits
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length >= 12 && !allowedKeys.includes(key)) {
      event.preventDefault();
    }
  }
  get panNumber() {
    return this.registrationForm.get('pan_no');
  }
  get gstnNumber() {
    return this.registrationForm.get(
      'primary_address.tax_details.gstn'
    );
  }

  get vendorCode() {
    return this.registrationForm.get('vendor_code')!;
  }

  onActiveIndexChange(event: number) {
    this.activeIndex = event;
  }

  setGSTNValidation() {
    const gstnControl = this.registrationForm.get(
      'primary_address.tax_details.gstn'
    );
    if (this.isGSTRegistered()) {
      gstnControl?.setValidators([Validators.required]);
    } else {
      gstnControl?.clearValidators();
    }
    gstnControl?.updateValueAndValidity();
  }

  isGSTRegistered(): boolean {
    return this.registrationForm.get('gst_registered')?.value === 'Yes';
  }
  isCountryIndia(country: string | null): boolean {
    if (!country) return false;
    const lowercaseCountry = country.toLowerCase();
    return ['india', 'in', 'ind'].includes(lowercaseCountry);
  }

  next() {
    if (this.activeIndex < this.items.length - 1) {
      this.activeIndex++;
    }
  }

  prev() {
    if (this.activeIndex > 0) {
      this.activeIndex--;
    }
  }

  emailMatchValidator(formGroup: FormGroup): ValidationErrors | null {
    const e_mail_id = formGroup.get(
      'primary_address.contact_person.e_mail_id'
    )?.value;
    const alternate_email_id = formGroup.get(
      'primary_address.contact_person.alternate_email_id'
    )?.value;
    const primaryAddressEmail = formGroup.get(
      'primary_address.email_address'
    )?.value;

    // if (e_mail_id && !(e_mail_id === primaryAddressEmail || e_mail_id === alternate_email_id)) {
    //   return { emailMatch: true };
    // }
    // else if (alternate_email_id && alternate_email_id === primaryAddressEmail) {
    //   return { emailMatch: true };
    // }
    // else {
    //   return null;
    // }
    if (primaryAddressEmail && primaryAddressEmail === e_mail_id) {
      return { emailMatch1: true, emailMatch: true };
    } else if (e_mail_id && e_mail_id === alternate_email_id) {
      return { emailMatch2: true, emailMatch1: true };
    } else if (
      alternate_email_id &&
      alternate_email_id === primaryAddressEmail
    ) {
      return { emailMatch: true, emailMatch2: true };
    } else {
      return null;
    }
  }
  getLoggedInUser() {
    this.authService
      .getLoggedInUser()
      .then((user) => {
        this.loggedInUser = user;
      })
      .catch((error) => {
        console.error('Error fetching logged-in user:', error);
      });
  }

  validateNumber(event: KeyboardEvent) {
    if (
      !/[0-9]/.test(event.key) &&
      !event.ctrlKey &&
      !['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(
        event.key
      )
    ) {
      event.preventDefault();
    }
  }

  getPlantList(vendorDetail:any) {
    this.shipment_asn
      .getPlantList()
      .then((res: any[]) => {
        // this.plantList = res;
        res.forEach((data)=>{
          let plant:PlantWithCode = {
            plant__code:data.plant__code,
            name1: `${data.plant__code}-${data.name1}`
          }
          this.plantList.push(plant)
        })
        this.fetchVendorDetails(vendorDetail)
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  onCheckbox(event: any) {
  }

  // disableSubmit: boolean = false;

  // submitForm() {
  //   // const checkbox = this.registrationForm.get('note');
  //   // if (checkbox) {
  //   //   if (checkbox.value === true) {
  //   //     this.disableSubmit = checkbox.value;
  //   //     console.log(this.disableSubmit);
  //   //   }
  //   // }
  // const plantControl = this.registrationForm.get('plant');
  // if (plantControl) {
  //   if (plantControl.value) {
  //     plantControl.setValue(plantControl.value.name);
  //   }
  // } else {
  //   console.error("'plant' control does not exist in the form.");
  // }
  // console.log(this.registrationForm.value);
  // }

  hideState: boolean = false

  onStateChange(selectedValue: any) {
    if (selectedValue === "IN") {
      this.hideState = true
    } else {
      this.hideState = false
    }
  }

  parseGenericErrorMessage(errorResponse: any): string {
    try {
      if (errorResponse._server_messages) {
        const serverMessages = JSON.parse(errorResponse._server_messages);
        if (Array.isArray(serverMessages) && serverMessages.length > 0) {
          const firstMessageParsed = JSON.parse(serverMessages[0]);
          if (firstMessageParsed && firstMessageParsed.message) {
            return firstMessageParsed.message;
          }
        }
      }

      const rawErrorMessage = errorResponse.message?.message;
      if (!rawErrorMessage) {
        return 'An unexpected error occurred. Please try again.';
      }

      const regex = /Duplicate entry '([^']*)' for key '([^']*)'/;
      const matches = rawErrorMessage.match(regex);

      if (matches && matches.length === 3) {
        const fieldNameReadable = matches[2].replace(/_/g, ' ').toLowerCase();
        const fieldNameCapitalized = fieldNameReadable.replace(
          /\b[a-z]/g,
          (char: string) => char.toUpperCase()
        );
        return `${fieldNameCapitalized} (Duplicate entry '${matches[1]}') is already in use. Please choose a different one.`;
      } else {
        return (
          rawErrorMessage || 'An unexpected error occurred. Please try again.'
        );
      }
    } catch (error) {
      console.error('Error processing the error message:', error);
      return 'An error occurred while processing the error message. Please try again.';
    }
  }

  closeDialog() {
    this.displayDialog = false;
  }

  evaluationSheetFormatDownload2L() {
    const downloadUrl = this.FRAPPE_API_URL_PROD + '/files/Rockman_ Vendor Evaluation Check list_Annexure1.xlsx';
    window.location.href = downloadUrl;
  }

  evaluationSheetFormatDownload5L() {
    const downloadUrl = this.FRAPPE_API_URL_PROD + '/files/Vendor Evaluation Check list  -Annexure-3.xlsx';
    window.location.href = downloadUrl;
  }

  selfDeclarationByVendorFormDownload() {
    const downloadUrl = this.FRAPPE_API_URL_PROD + '/files/Declaration On No Child Labour NO RPT.docx';
    window.location.href = downloadUrl;
  }

  SelectIndustryType1(event:any){
    if (event === '0001' || event === '0002' || event === '0003') {
      this.isIndustry = true
    }else if (event === '0004' || event === '0005' ) {
      this.isIndustry = false
    }else{
      this.isIndustry = false
    }
  }

  ngOnDestroy(): void { }
}

